const containerStyleObjects = {
	sizing_label: {active: false, type: 'label', text: 'Sizing', parentname: 'sizing_label'},
	containerStyle: {active: false, type: 'radiogroup', isButton: true, value: 'container', options: [{text: 'Container', value: 'container'}, {text: 'Fullwidth', value: 'container-fluid'}, {text: 'Custom', value: ''}]},
	background_label: {active: false, type: 'label', text: 'Background Options', parentname: 'background_label'},
	background: {
		active: true,
		size: 'contain',
		custom_size: 100,
		position: 'center center',
		repeat: 'repeat',
		image_repeat_options: ['repeat','repeat-x','repeat-y','no-repeat','initial','inherit'],
		image_size_options: ['auto', 'contain', 'cover', 'custom'],
		image_position_options: ['top right', 'top left', 'top center', 'center right', 'center left', 'center center', 'bottom right', 'bottom left', 'bottom center'],
		type: 'background',
		value: ['background', 'transparent'],
		options: [{text: 'transparent', value: ['background', 'transparent'], icon: 'bx bx'}, {text: 'Image', value: ['background-image', ''], icon: 'bx bx'}, {text: 'Colour', value: ['background-color', ''], icon: 'bx bx'}]
	},
	width: {active: false, type: 'range', value: '', units: '%', unit_options: ['px', '%'],  max: 100, min: 0, parentlabel: 'sizing_label'},
	max_width: {active: false, type: 'range', value: '', units: '%', unit_options: ['px', '%'],  max: 100, min: 0, parentlabel: 'sizing_label'},
	height: {active: false, type: 'range', value: '', units: '%', unit_options: ['px', '%'],  max: 100, min: 0, parentlabel: 'sizing_label'},
	max_height: {active: false, type: 'range', value: '', units: '%', unit_options: ['px', '%'],  max: 100, min: 0, parentlabel: 'sizing_label'}, 
	spacing_label: {active: false, type: 'label', text: 'Spacing', parentname: 'spacing_label'},
	padding: {
		active: false,
		type: 'numbergroup',
		parentlabel: '',
		left: null,
		right: null,
		top: null,
		bottom: null, 
	},
	margin: {
		active: false,
		type: 'numbergroup',
		parentlabel: '',
		left: null,
		right: null,
		top: null,
		bottom: null,
	},
	border_label: {active: false, type: 'label', text: 'Borders', parentname: 'border_label'},
	border_style: {
			active: false, type: 'select', value: '', options: ['dotted','dashed','solid','double','groove','ridge','inset','outset','none','hidden']
	},
	border: {
		active: true,
		type: 'numbergroup',
		parentlabel: '',
		left: 0,
		right: 0,
		top: 0,
		bottom: 0,
	},
	border_colour: {
		active: false,
		value: '#000000',
		type: 'color'
	},
	border_radius: {
		active: false,
		type: 'numbergroup',
		parentlabel: '',
		top_left: null,
		top_right: null,
		bottom_left: null,
		bottom_right: null,
	},
	alignment_label: {active: false, type: 'label', text: 'Content Alignment', parentname: 'alignment_label'},
	vertical_align: {active: false, type: 'radiogroup', isButton: true, value: 'top', options: ['top', 'middle', 'bottom']},
	horizontal_align: {active: false, type: 'radiogroup', isButton: true, value: 'left', options: ['left', 'center', 'right']},
};

const containerStyles = [
	{sizing_label: {id: 1, active: false, type: 'label', text: 'Sizing', parentname: 'sizing_label'},
	},
	{containerStyle: {id: 2, active: false, type: 'radiogroup', isButton: true, value: 'container', options: [{text: 'Container', value: 'container'}, {text: 'Fullwidth', value: 'container-fullwidth'}, {text: 'Custom', value: ''}]},
	},
	{background_label: {id: 3, active: false, type: 'label', text: 'Background Options', parentname: 'background_label'},
	},
	{background: {id: 4, 
		active: true,
		size: 'contain',
		custom_size: 100,
		position: 'center center',
		repeat: 'repeat',
		image_repeat_options: ['repeat','repeat-x','repeat-y','no-repeat','initial','inherit'],
		image_size_options: ['auto', 'contain', 'cover', 'custom'],
		image_position_options: ['top right', 'top left', 'top center', 'center right', 'center left', 'center center', 'bottom right', 'bottom left', 'bottom center'],
		type: 'background',
		value: ['background', 'transparent'],
		options: [{text: 'transparent', value: ['background', 'transparent'], icon: 'bx bx'}, {text: 'Image', value: ['background-image', ''], icon: 'bx bx'}, {text: 'Colour', value: ['background-color', ''], icon: 'bx bx'}]
	},
	},
	{width: {id: 5, active: false, type: 'range', value: '', units: '%', unit_options: ['px', '%'],  max: 100, min: 0, parentlabel: 'sizing_label'},
	},
	{max_width: {id: 6, active: false, type: 'range', value: '', units: '%', unit_options: ['px', '%'],  max: 100, min: 0, parentlabel: 'sizing_label'},
	},
	{height: {id: 7, active: false, type: 'range', value: '', units: '%', unit_options: ['px', '%'],  max: 100, min: 0, parentlabel: 'sizing_label'},
	},
	{max_height: {id: 8, active: false, type: 'range', value: '', units: '%', unit_options: ['px', '%'],  max: 100, min: 0, parentlabel: 'sizing_label'}, 
	},
	{spacing_label: {id: 9, active: false, type: 'label', text: 'Spacing', parentname: 'spacing_label'},
	},
	{padding: {id: 10, 
		active: false,
		type: 'numbergroup',
		parentlabel: '',
		left: null,
		right: null,
		top: null,
		bottom: null, 
	},
	},
	{margin: {id: 11, 
		active: false,
		type: 'numbergroup',
		parentlabel: '',
		left: null,
		right: null,
		top: null,
		bottom: null,
	},
	},
	{border_label: {id: 12, active: false, type: 'label', text: 'Borders', parentname: 'border_label'},
	},
	{border_style: {id: 13, 
			active: false, type: 'select', value: '', options: ['dotted','dashed','solid','double','groove','ridge','inset','outset','none','hidden']
	},
	},
	{border: {id: 14, 
		active: true,
		type: 'numbergroup',
		parentlabel: '',
		left: 0,
		right: 0,
		top: 0,
		bottom: 0,
	},
	},
	{border_colour: {id: 15, 
		active: false,
		value: '#000000',
		type: 'color'
	},
	},
	{border_radius: {id: 16, 
		active: false,
		type: 'numbergroup',
		parentlabel: '',
		top_left: null,
		top_right: null,
		bottom_left: null,
		bottom_right: null,
	},
	},
	{alignment_label: {id: 17, active: false, type: 'label', text: 'Content Alignment', parentname: 'alignment_label'},
	},
	{vertical_align: {id: 18, active: false, type: 'radiogroup', isButton: true, value: 'top', options: ['top', 'middle', 'bottom']},
	},
	{horizontal_align: {id: 19, active: false, type: 'radiogroup', isButton: true, value: 'left', options: ['left', 'center', 'right']},
}];

const rowStyleObjects = {
	background_label: {active: false, type: 'label', text: 'Background Options', parentname: 'background_label'},
	background: {
		size: 'contain',
		custom_size: 100,
		position: 'center center',
		repeat: 'repeat',
		image_repeat_options: ['repeat','repeat-x','repeat-y','no-repeat','initial','inherit'],
		image_size_options: ['auto', 'contain', 'cover', 'custom'],
		image_position_options: ['top right', 'top left', 'top center', 'center right', 'center left', 'center center', 'bottom right', 'bottom left', 'bottom center'],
		type: 'background',
		value: ['background', 'transparent'],
		options: [{text: 'transparent', value: ['background', 'transparent'], icon: 'bx bx'}, {text: 'Image', value: ['background-image', ''], icon: 'bx bx'}, {text: 'Colour', value: ['background-color', ''], icon: 'bx bx'}]
	},
	sizing_label: {active: false, type: 'label', text: 'Sizing', parentname: 'sizing_label'},
	width: {active: false, type: 'range', value: 100, units: '%', unit_options: ['px', '%'],  max: 100, min: 0, parentlabel: 'sizing_label'},
	max_width: {active: false, type: 'range', value: 100, units: '%', unit_options: ['px', '%'],  max: 100, min: 0, parentlabel: 'sizing_label'},
	height: {active: false, type: 'range', value: 100, units: '%', unit_options: ['px', '%'],  max: 100, min: 0, parentlabel: 'sizing_label'},
	max_height: {active: false, type: 'range', value: 100, units: '%', unit_options: ['px', '%'],  max: 100, min: 0, parentlabel: 'sizing_label'}, 
	spacing_label: {active: false, type: 'label', text: 'Spacing', parentname: 'spacing_label'},
	padding: {
		active: false,
		type: 'numbergroup',
		left: null,
		right: null,
		top: null,
		bottom: null, 
	},
	margin: {
		active: false,
		type: 'numbergroup',
		left: null,
		right: null,
		top: null,
		bottom: null,
	},
	border_label: {active: false, type: 'label', text: 'Borders', parentname: 'border_label'},
	border_style: {
			active: false, type: 'select', value: 'solid', options: ['dotted','dashed','solid','double','groove','ridge','inset','outset','none','hidden']
	},
	border: {
		active: true,
		type: 'numbergroup',
		left: 0,
		right: 0,
		top: 0,
		bottom: 0,
	},
	border_radius: {
		active: false,
		type: 'numbergroup',
		left: null,
		right: null,
		top: null,
		bottom: null,
	},
	border_colour: {
		active: false,
		value: '#000000',
		type: 'color'
	},
	alignment_label: {active: false, type: 'label', text: 'Content Alignment', parentname: 'alignment_label'},
		vertical_align: {active: false, type: 'radiogroup', isButton: true, value: 'top', options: ['top', 'middle', 'bottom']},
	horizontal_align: {active: false, type: 'radiogroup', isButton: true, value: 'left', options: ['left', 'center', 'right']},
};


const rowStyles = [
	{background_label: {active: false, type: 'label', text: 'Background Options', parentname: 'background_label'},
	},
	{background: {
		size: 'contain',
		custom_size: 100,
		position: 'center center',
		repeat: 'repeat',
		image_repeat_options: ['repeat','repeat-x','repeat-y','no-repeat','initial','inherit'],
		image_size_options: ['auto', 'contain', 'cover', 'custom'],
		image_position_options: ['top right', 'top left', 'top center', 'center right', 'center left', 'center center', 'bottom right', 'bottom left', 'bottom center'],
		type: 'background',
		value: ['background', 'transparent'],
		options: [{text: 'transparent', value: ['background', 'transparent'], icon: 'bx bx'}, {text: 'Image', value: ['background-image', ''], icon: 'bx bx'}, {text: 'Colour', value: ['background-color', ''], icon: 'bx bx'}]
	},
	},
	{sizing_label: {active: false, type: 'label', text: 'Sizing', parentname: 'sizing_label'},
	},
	{width: {active: false, type: 'range', value: 100, units: '%', unit_options: ['px', '%'],  max: 100, min: 0, parentlabel: 'sizing_label'},
	},
	{max_width: {active: false, type: 'range', value: 100, units: '%', unit_options: ['px', '%'],  max: 100, min: 0, parentlabel: 'sizing_label'},
	},
	{height: {active: false, type: 'range', value: 100, units: '%', unit_options: ['px', '%'],  max: 100, min: 0, parentlabel: 'sizing_label'},
	},
	{max_height: {active: false, type: 'range', value: 100, units: '%', unit_options: ['px', '%'],  max: 100, min: 0, parentlabel: 'sizing_label'}, 
	},
	{spacing_label: {active: false, type: 'label', text: 'Spacing', parentname: 'spacing_label'},
	},
	{padding: {
		active: false,
		type: 'numbergroup',
		left: null,
		right: null,
		top: null,
		bottom: null, 
	},
	},
	{margin: {
		active: false,
		type: 'numbergroup',
		left: null,
		right: null,
		top: null,
		bottom: null,
	},
	},
	{border_label: {active: false, type: 'label', text: 'Borders', parentname: 'border_label'},
	},
	{
	  border_style: { active: false, type: 'select', value: 'solid', options: ['dotted','dashed','solid','double','groove','ridge','inset','outset','none','hidden']},
	},
	{border: {
		active: true,
		type: 'numbergroup',
		left: 0,
		right: 0,
		top: 0,
		bottom: 0,
	},
	},
	{border_radius: {
		active: false,
		type: 'numbergroup',
		left: null,
		right: null,
		top: null,
		bottom: null,
	},
	},
	{border_colour: {
		active: false,
		value: '#000000',
		type: 'color'
	},
	},
	{alignment_label: {active: false, type: 'label', text: 'Content Alignment', parentname: 'alignment_label'},
		},
		{vertical_align: {active: false, type: 'radiogroup', isButton: true, value: 'top', options: ['top', 'middle', 'bottom']},
	},
	{horizontal_align: {active: false, type: 'radiogroup', isButton: true, value: 'left', options: ['left', 'center', 'right']},
}];

const columnStyleObjects = {
	background_label: {active: false, type: 'label', text: 'Background Options', parentname: 'background_label'},
	background: {
		size: 'contain',
		custom_size: 100,
		position: 'center center',
		repeat: 'repeat',
		image_repeat_options: ['repeat','repeat-x','repeat-y','no-repeat','initial','inherit'],
		image_size_options: ['auto', 'contain', 'cover', 'custom'],
		image_position_options: ['top right', 'top left', 'top center', 'center right', 'center left', 'center center', 'bottom right', 'bottom left', 'bottom center'],
		type: 'background',
		value: ['background', 'transparent'],
		options: [{text: 'transparent', value: ['background', 'transparent'], icon: 'bx bx'}, {text: 'Image', value: ['background-image', ''], icon: 'bx bx'}, {text: 'Colour', value: ['background-color', ''], icon: 'bx bx'}]
	},
	background_parallax: {
		type: 'radiogroup',
		isButton: true,
		options: [true, false],
		value: false,
	},
	sizing_label: {active: false, type: 'label', text: 'Sizing', parentname: 'sizing_label'},
	size: {active: false, type: 'cols', xl: 12, lg: 12, md: 12, sm: 12, xs: 12, parentlabel: 'sizing_label'},
	width: {active: false, type: 'range', value: 100, units: '%', unit_options: ['px', '%'],  max: 100, min: 0, parentlabel: 'sizing_label'},
	max_width: {active: false, type: 'range', value: 100, units: '%', unit_options: ['px', '%'],  max: 100, min: 0, parentlabel: 'sizing_label'},
	height: {active: false, type: 'range', value: 100, units: '%', unit_options: ['px', '%'],  max: 100, min: 0, parentlabel: 'sizing_label'},
	max_height: {active: false, type: 'range', value: 100, units: '%', unit_options: ['px', '%'],  max: 100, min: 0, parentlabel: 'sizing_label'}, 
	spacing_label: {active: false, type: 'label', text: 'Spacing', parentname: 'spacing_label'},
	padding: {
		parentlabel: 'spacing_label',
		active: false,
		type: 'numbergroup',
		left: null,
		right: null,
		top: null,
		bottom: null, 
	},
	margin: {
		parentlabel: 'spacing_label',
		active: false,
		type: 'numbergroup',
		left: null,
		right: null,
		top: null,
		bottom: null,
	},
	border_label: {active: false, type: 'label', text: 'Borders', parentname: 'border_label'},
	border: {
		parentlabel: 'border_label',
		active: false,
		type: 'numbergroup',
		left: null,
		right: null,
		top: null,
		bottom: null,
	},
	border_radius: {
		parentlabel: 'border_label',
		active: false,
		type: 'numbergroup',
		left: 0,
		right: 0,
		top: 0,
		bottom: 0,
	},
	border_colour: {
		value: '#000000',
		type: 'color'
	},
	border_style: {
			type: 'select', value: 'solid', options: ['dotted','dashed','solid','double','groove','ridge','inset','outset','none','hidden']
	},
	column_templates: {
		type: 'hidden',
		oneColSize:  {active: false, type: 'cols', xl: 12, lg: 12, md: 12, sm: 12, xs: 12 },
		twoColSize:  {active: false, type: 'cols', xl: 6, lg: 6, md: 6, sm: 12, xs: 12 },
		threeColSize:  {active: false, type: 'cols', xl: 4, lg: 4, md: 4, sm: 12, xs: 12 },
		fourColSize:  {active: false, type: 'cols', xl: 3, lg: 3, md: 3, sm: 6, xs: 12 },
		sixColSize:  {active: false, type: 'cols', xl: 2, lg: 2, md: 2, sm: 4, xs: 6 },
		oneColEightSize: {active: false, type: 'cols', xl: 8, lg: 8, md: 8, sm: 12, xs: 12 },
		oneColSevenSize: {active: false, type: 'cols', xl: 7, lg: 7, md: 7, sm: 12, xs: 12 },
		oneColOneSize: {active: false, type: 'cols', xl: 1, lg: 1, md: 1, sm: 12, xs: 12 },
	},
	alignment_label: {active: false, type: 'label', text: 'Content Alignment', parentname: 'alignment_label'},
	vertical_align: {active: false, type: 'radiogroup', isButton: true, value: 'top', options: ['top', 'middle', 'bottom']},
	horizontal_align: {active: false, type: 'radiogroup', isButton: true, value: 'left', options: ['left', 'center', 'right']},
};

const columnStyles = [
	{background_label: {id: 1, active: false, type: 'label', text: 'Background Options', parentname: 'background_label'},
	},
	{background: {id: 2, 
		size: 'contain',
		custom_size: 100,
		position: 'center center',
		repeat: 'repeat',
		image_repeat_options: ['repeat','repeat-x','repeat-y','no-repeat','initial','inherit'],
		image_size_options: ['auto', 'contain', 'cover', 'custom'],
		image_position_options: ['top right', 'top left', 'top center', 'center right', 'center left', 'center center', 'bottom right', 'bottom left', 'bottom center'],
		type: 'background',
		value: ['background', 'transparent'],
		options: [{text: 'transparent', value: ['background', 'transparent'], icon: 'bx bx'}, {text: 'Image', value: ['background-image', ''], icon: 'bx bx'}, {text: 'Colour', value: ['background-color', ''], icon: 'bx bx'}]
	},
	},
	{background_parallax: {id: 3, 
		type: 'radiogroup',
		isButton: true,
		options: [true, false],
		value: false,
	},
	},
	{sizing_label: {id: 4, active: false, type: 'label', text: 'Sizing', parentname: 'sizing_label'},
	},
	{size: {id: 5, active: false, type: 'cols', xl: 12, lg: 12, md: 12, sm: 12, xs: 12, parentlabel: 'sizing_label'},
	},
	{width: {id: 6, active: false, type: 'range', value: 100, units: '%', unit_options: ['px', '%'],  max: 100, min: 0, parentlabel: 'sizing_label'},
	},
	{max_width: {id: 7, active: false, type: 'range', value: 100, units: '%', unit_options: ['px', '%'],  max: 100, min: 0, parentlabel: 'sizing_label'},
	},
	{height: {id: 8, active: false, type: 'range', value: 100, units: '%', unit_options: ['px', '%'],  max: 100, min: 0, parentlabel: 'sizing_label'},
	},
	{max_height: {id: 9, active: false, type: 'range', value: 100, units: '%', unit_options: ['px', '%'],  max: 100, min: 0, parentlabel: 'sizing_label'}, 
	},
	{spacing_label: {id: 10, active: false, type: 'label', text: 'Spacing', parentname: 'spacing_label'},
	},
	{padding: {id: 11, 
		parentlabel: 'spacing_label',
		active: false,
		type: 'numbergroup',
		left: null,
		right: null,
		top: null,
		bottom: null, 
	},
	},
	{margin: {id: 12, 
		parentlabel: 'spacing_label',
		active: false,
		type: 'numbergroup',
		left: null,
		right: null,
		top: null,
		bottom: null,
	},
	},
	{border_label: {id: 13, active: false, type: 'label', text: 'Borders', parentname: 'border_label'},
	},
	{border: {id: 14, 
		parentlabel: 'border_label',
		active: false,
		type: 'numbergroup',
		left: null,
		right: null,
		top: null,
		bottom: null,
	},
	},
	{border_radius: {id: 15, 
		parentlabel: 'border_label',
		active: false,
		type: 'numbergroup',
		left: 0,
		right: 0,
		top: 0,
		bottom: 0,
	},
	},
	{border_colour: {id: 16, 
		value: '#000000',
		type: 'color'
	},
	},
	{border_style: {id: 17, 
			type: 'select', value: 'solid', options: ['dotted','dashed','solid','double','groove','ridge','inset','outset','none','hidden']
	},
	},
	{column_templates: {id: 18, 
		type: 'hidden',
		oneColSize:  {active: false, type: 'cols', xl: 12, lg: 12, md: 12, sm: 12, xs: 12 },
		twoColSize:  {active: false, type: 'cols', xl: 6, lg: 6, md: 6, sm: 12, xs: 12 },
		threeColSize:  {active: false, type: 'cols', xl: 4, lg: 4, md: 4, sm: 12, xs: 12 },
		fourColSize:  {active: false, type: 'cols', xl: 3, lg: 3, md: 3, sm: 6, xs: 12 },
		sixColSize:  {active: false, type: 'cols', xl: 2, lg: 2, md: 2, sm: 4, xs: 6 },
		oneColEightSize: {active: false, type: 'cols', xl: 8, lg: 8, md: 8, sm: 12, xs: 12 },
		oneColSevenSize: {active: false, type: 'cols', xl: 7, lg: 7, md: 7, sm: 12, xs: 12 },
		oneColOneSize: {active: false, type: 'cols', xl: 1, lg: 1, md: 1, sm: 12, xs: 12 },
	},
	},
	{alignment_label: {id: 19, active: false, type: 'label', text: 'Content Alignment', parentname: 'alignment_label'},
	},
	{vertical_align: {id: 20, active: false, type: 'radiogroup', isButton: true, value: 'top', options: ['top', 'middle', 'bottom']},
	},
	{horizontal_align: {id: 21, active: false, type: 'radiogroup', isButton: true, value: 'left', options: ['left', 'center', 'right']}}
];

const widgetStyles = [
	{background_label: {active: false, type: 'label', text: 'Background Options', parentname: 'background_label'},
	},
	{background: {
		active: true,
		size: 'contain',
		custom_size: 100,
		position: 'center center',
		repeat: 'repeat',
		image_repeat_options: ['repeat','repeat-x','repeat-y','no-repeat','initial','inherit'],
		image_size_options: ['auto', 'contain', 'cover', 'custom'],
		image_position_options: ['top right', 'top left', 'top center', 'center right', 'center left', 'center center', 'bottom right', 'bottom left', 'bottom center'],
		type: 'background',
		value: ['background', 'transparent'],
		options: [{text: 'transparent', value: ['background', 'transparent'], icon: 'bx bx'}, {text: 'Image', value: ['background-image', ''], icon: 'bx bx'}, {text: 'Colour', value: ['background-color', ''], icon: 'bx bx'}]
	},
	},
	{sizing_label: {active: false, type: 'label', text: 'Sizing Options', parentname: 'background_label'},
	},
	{width: {active: false, type: 'range', value: '', units: '%', unit_options: ['px', '%'],  max: 100, min: 0, parentlabel: 'sizing_label'},
	},
	{max_width: {active: false, type: 'range', value: '', units: '%', unit_options: ['px', '%'],  max: 100, min: 0, parentlabel: 'sizing_label'},
	},
	{height: {active: false, type: 'range', value: '', units: '%', unit_options: ['px', '%'],  max: 100, min: 0, parentlabel: 'sizing_label'},
	},
	{max_height: {active: false, type: 'range', value: '', units: '%', unit_options: ['px', '%'],  max: 100, min: 0, parentlabel: 'sizing_label'}, 
	},
	{spacing_label: {active: false, type: 'label', text: 'Spacing', parentname: 'spacing_label'},
	},
	{padding: {
		active: false,
		type: 'numbergroup',
		parentlabel: '',
		left: null,
		right: null,
		top: null,
		bottom: null, 
	},
	},
	{margin: {
		active: false,
		type: 'numbergroup',
		parentlabel: '',
		left: null,
		right: null,
		top: null,
		bottom: null,
	},
	},
	{border_label: {active: false, type: 'label', text: 'Borders', parentname: 'border_label'},
	},
	{border_style: {
			active: false, type: 'select', value: '', options: ['dotted','dashed','solid','double','groove','ridge','inset','outset','none','hidden']
	},
	},
	{border: {
		active: true,
		type: 'numbergroup',
		parentlabel: '',
		left: 0,
		right: 0,
		top: 0,
		bottom: 0,
	},
	},
	{border_colour: {
		active: false,
		value: '#000000',
		type: 'color'
	},
	},
	{border_radius: {
		active: false,
		type: 'numbergroup',
		parentlabel: '',
		top_left: null,
		top_right: null,
		bottom_left: null,
		bottom_right: null,
	},
	},
	{alignment_label: {active: false, type: 'label', text: 'Content Alignment', parentname: 'alignment_label'},
	},
	{display: {active: false, type: 'radiogroup', isButton: true, value: 'block', options: ['inline', 'block', 'flex']},
	},
	{vertical_align: {active: false, type: 'radiogroup', isButton: true, value: 'top', options: ['top', 'middle', 'bottom']},
	},
	{horizontal_align: {active: false, type: 'radiogroup', isButton: true, value: 'left', options: ['left', 'center', 'right']},
}];

const themeStyles = {
	themecontent: [
		{logo: {
                        active: true,
                        width: {value: 'auto', units: ''},
                        height: {value: 65, units: ''},
                        value: '',
                        units: '',
                        subfields: [
                          {width: {active: false, type: 'range', value: 'auto', units: '%', unit_options: ['px', '%'], max: 100, min: 0, parentlabel: 'imgsize_label'},
                          },
                          {height: {active: false, type: 'range', value: 'auto', units: '%', unit_options: ['px', '%'], max: 100, min: 0, parentlabel: 'imgsize_label'},
                          }
                        ]
                      },
                  },
                  {banner: {
                        active: true,
                        width: {value: '100', units: '%'},
                        height: {value: '', units: ''},
                        value: '',
                        units: '',
                        subfields: [
                          {width: {active: false, type: 'range', value: 'auto', units: '%', unit_options: ['px', '%'], max: 100, min: 0, parentlabel: 'imgsize_label'},
                          },
                          {height: {active: false, type: 'range', value: 'auto', units: '%', unit_options: ['px', '%'], max: 100, min: 0, parentlabel: 'imgsize_label'},
                          }
                        ]
                      },
                  },
	],
	themeconfigs: [
		{logo: {
                        active: true,
                        custom_size: 100,
                        image_repeat_options: ['repeat','repeat-x','repeat-y','no-repeat','initial','inherit'],
                        image_size_options: ['auto', 'contain', 'cover', 'custom'],
                        image_position_options: ['top right', 'top left', 'top center', 'center right', 'center left', 'center center', 'bottom right', 'bottom left', 'bottom center'],
                        type: 'image',
                        value: '',
                        subfields: [
                          {imgsize_label: {active: false, type: 'label', text: 'Image Size', parentname: 'imgsize_label'},
                          },
                          {width: {active: false, type: 'range', value: 'auto', units: '%', unit_options: ['px', '%'], max: 100, min: 0, parentlabel: 'imgsize_label'},
                          },
                          {height: {active: false, type: 'range', value: 'auto', units: '%', unit_options: ['px', '%'], max: 100, min: 0, parentlabel: 'imgsize_label'},
                          }
                        ]
            },
        },
        {banner: {
                        active: true,
                        custom_size: 100,
                        image_repeat_options: ['repeat','repeat-x','repeat-y','no-repeat','initial','inherit'],
                        image_size_options: ['auto', 'contain', 'cover', 'custom'],
                        image_position_options: ['top right', 'top left', 'top center', 'center right', 'center left', 'center center', 'bottom right', 'bottom left', 'bottom center'],
                        type: 'image',
                        value: '',
                        subfields: [
                          {imgsize_label: {active: false, type: 'label', text: 'Image Size', parentname: 'imgsize_label'},
                          },
                          {width: {active: false, type: 'range', value: 'auto', units: '%', unit_options: ['px', '%'], max: 100, min: 0, parentlabel: 'imgsize_label'},
                          },
                          {height: {active: false, type: 'range', value: 'auto', units: '%', unit_options: ['px', '%'], max: 100, min: 0, parentlabel: 'imgsize_label'},
                          }
                        ]
            },
        },
	],
	elements: 
			[
				{colors: 
					{
						global_colors: [
									{
										primary__colour: {
												active: false,
												value: '#000000',
												type: 'color'
											},
									},
									{
										secondary__colour: {
												active: false,
												value: '#000000',
												type: 'color'
											},
									},
															
							],
						
					},
				},
				{headers: 
					{
						h1: [
							{font_size: {active: false, type: 'range', value: 'auto', units: '', unit_options: ['px'],  max: 124, min: 0, parentlabel: 'sizing_label'},
                           },
                           {font_family: {value: {"family":"Poppins","variants":["100","100italic","200","200italic","300","300italic","regular","italic","500","500italic","600","600italic","700","700italic","800","800italic","900","900italic"],"subsets":["devanagari","latin","latin-ext"],"version":"v20","lastModified":"2022-09-22","files":{"100":"http://fonts.gstatic.com/s/poppins/v20/pxiGyp8kv8JHgFVrLPTed3FBGPaTSQ.ttf","200":"http://fonts.gstatic.com/s/poppins/v20/pxiByp8kv8JHgFVrLFj_V1tvFP-KUEg.ttf","300":"http://fonts.gstatic.com/s/poppins/v20/pxiByp8kv8JHgFVrLDz8V1tvFP-KUEg.ttf","500":"http://fonts.gstatic.com/s/poppins/v20/pxiByp8kv8JHgFVrLGT9V1tvFP-KUEg.ttf","600":"http://fonts.gstatic.com/s/poppins/v20/pxiByp8kv8JHgFVrLEj6V1tvFP-KUEg.ttf","700":"http://fonts.gstatic.com/s/poppins/v20/pxiByp8kv8JHgFVrLCz7V1tvFP-KUEg.ttf","800":"http://fonts.gstatic.com/s/poppins/v20/pxiByp8kv8JHgFVrLDD4V1tvFP-KUEg.ttf","900":"http://fonts.gstatic.com/s/poppins/v20/pxiByp8kv8JHgFVrLBT5V1tvFP-KUEg.ttf","100italic":"http://fonts.gstatic.com/s/poppins/v20/pxiAyp8kv8JHgFVrJJLmE3tFOvODSVFF.ttf","200italic":"http://fonts.gstatic.com/s/poppins/v20/pxiDyp8kv8JHgFVrJJLmv1plEN2PQEhcqw.ttf","300italic":"http://fonts.gstatic.com/s/poppins/v20/pxiDyp8kv8JHgFVrJJLm21llEN2PQEhcqw.ttf","regular":"http://fonts.gstatic.com/s/poppins/v20/pxiEyp8kv8JHgFVrFJDUc1NECPY.ttf","italic":"http://fonts.gstatic.com/s/poppins/v20/pxiGyp8kv8JHgFVrJJLed3FBGPaTSQ.ttf","500italic":"http://fonts.gstatic.com/s/poppins/v20/pxiDyp8kv8JHgFVrJJLmg1hlEN2PQEhcqw.ttf","600italic":"http://fonts.gstatic.com/s/poppins/v20/pxiDyp8kv8JHgFVrJJLmr19lEN2PQEhcqw.ttf","700italic":"http://fonts.gstatic.com/s/poppins/v20/pxiDyp8kv8JHgFVrJJLmy15lEN2PQEhcqw.ttf","800italic":"http://fonts.gstatic.com/s/poppins/v20/pxiDyp8kv8JHgFVrJJLm111lEN2PQEhcqw.ttf","900italic":"http://fonts.gstatic.com/s/poppins/v20/pxiDyp8kv8JHgFVrJJLm81xlEN2PQEhcqw.ttf"},"category":"sans-serif","kind":"webfonts#webfont"}, type: 'fontselect', options: []},
                           },
                           {font_style: {value: '', type: 'select', options: ['normal','italic','oblique','initial','inherit']},
                           },
                           {font_weight: {value: '', type: 'select', options: [100,200,300,400,500,600,700,800,900]},
                           },
                           {text_transform: {value: '', type: 'select', options: ['none','capitalize','uppercase','lowercase','initial','inherit']},
                           },
                           {letter_spacing: {active: false, type: 'range', value: 'auto', units: '', unit_options: ['px'],  max: 124, min: 0, parentlabel: 'sizing_label'},
                           },
                           {line_height: {active: false, type: 'range', value: 'auto', units: '', unit_options: ['px'],  max: 124, min: 0, parentlabel: 'sizing_label'}
                            },
                            {
								colour: {
									active: false,
									value: '#000000',
									type: 'color'
								},
							},
						],
						h2: [
							{font_size: {active: false, type: 'range', value: 'auto', units: '', unit_options: ['px'],  max: 124, min: 0, parentlabel: 'sizing_label'},
                           },
                           {font_family: {value: {"family":"Poppins","variants":["100","100italic","200","200italic","300","300italic","regular","italic","500","500italic","600","600italic","700","700italic","800","800italic","900","900italic"],"subsets":["devanagari","latin","latin-ext"],"version":"v20","lastModified":"2022-09-22","files":{"100":"http://fonts.gstatic.com/s/poppins/v20/pxiGyp8kv8JHgFVrLPTed3FBGPaTSQ.ttf","200":"http://fonts.gstatic.com/s/poppins/v20/pxiByp8kv8JHgFVrLFj_V1tvFP-KUEg.ttf","300":"http://fonts.gstatic.com/s/poppins/v20/pxiByp8kv8JHgFVrLDz8V1tvFP-KUEg.ttf","500":"http://fonts.gstatic.com/s/poppins/v20/pxiByp8kv8JHgFVrLGT9V1tvFP-KUEg.ttf","600":"http://fonts.gstatic.com/s/poppins/v20/pxiByp8kv8JHgFVrLEj6V1tvFP-KUEg.ttf","700":"http://fonts.gstatic.com/s/poppins/v20/pxiByp8kv8JHgFVrLCz7V1tvFP-KUEg.ttf","800":"http://fonts.gstatic.com/s/poppins/v20/pxiByp8kv8JHgFVrLDD4V1tvFP-KUEg.ttf","900":"http://fonts.gstatic.com/s/poppins/v20/pxiByp8kv8JHgFVrLBT5V1tvFP-KUEg.ttf","100italic":"http://fonts.gstatic.com/s/poppins/v20/pxiAyp8kv8JHgFVrJJLmE3tFOvODSVFF.ttf","200italic":"http://fonts.gstatic.com/s/poppins/v20/pxiDyp8kv8JHgFVrJJLmv1plEN2PQEhcqw.ttf","300italic":"http://fonts.gstatic.com/s/poppins/v20/pxiDyp8kv8JHgFVrJJLm21llEN2PQEhcqw.ttf","regular":"http://fonts.gstatic.com/s/poppins/v20/pxiEyp8kv8JHgFVrFJDUc1NECPY.ttf","italic":"http://fonts.gstatic.com/s/poppins/v20/pxiGyp8kv8JHgFVrJJLed3FBGPaTSQ.ttf","500italic":"http://fonts.gstatic.com/s/poppins/v20/pxiDyp8kv8JHgFVrJJLmg1hlEN2PQEhcqw.ttf","600italic":"http://fonts.gstatic.com/s/poppins/v20/pxiDyp8kv8JHgFVrJJLmr19lEN2PQEhcqw.ttf","700italic":"http://fonts.gstatic.com/s/poppins/v20/pxiDyp8kv8JHgFVrJJLmy15lEN2PQEhcqw.ttf","800italic":"http://fonts.gstatic.com/s/poppins/v20/pxiDyp8kv8JHgFVrJJLm111lEN2PQEhcqw.ttf","900italic":"http://fonts.gstatic.com/s/poppins/v20/pxiDyp8kv8JHgFVrJJLm81xlEN2PQEhcqw.ttf"},"category":"sans-serif","kind":"webfonts#webfont"}, type: 'fontselect', options: []},
                           },
                           {font_style: {value: '', type: 'select', options: ['normal','italic','oblique','initial','inherit']},
                           },
                           {font_weight: {value: '', type: 'select', options: [100,200,300,400,500,600,700,800,900]},
                           },
                           {text_transform: {value: '', type: 'select', options: ['none','capitalize','uppercase','lowercase','initial','inherit']},
                           },
                           {letter_spacing: {active: false, type: 'range', value: 'auto', units: '', unit_options: ['px'],  max: 124, min: 0, parentlabel: 'sizing_label'},
                           },
                           {line_height: {active: false, type: 'range', value: 'auto', units: '', unit_options: ['px'],  max: 124, min: 0, parentlabel: 'sizing_label'}
                            },
                            {
								colour: {
									active: false,
									value: '#000000',
									type: 'color'
								},
							},
						],
						h3: [
							{font_size: {active: false, type: 'range', value: 'auto', units: '', unit_options: ['px'],  max: 124, min: 0, parentlabel: 'sizing_label'},
                           },
                           {font_family: {value: {"family":"Poppins","variants":["100","100italic","200","200italic","300","300italic","regular","italic","500","500italic","600","600italic","700","700italic","800","800italic","900","900italic"],"subsets":["devanagari","latin","latin-ext"],"version":"v20","lastModified":"2022-09-22","files":{"100":"http://fonts.gstatic.com/s/poppins/v20/pxiGyp8kv8JHgFVrLPTed3FBGPaTSQ.ttf","200":"http://fonts.gstatic.com/s/poppins/v20/pxiByp8kv8JHgFVrLFj_V1tvFP-KUEg.ttf","300":"http://fonts.gstatic.com/s/poppins/v20/pxiByp8kv8JHgFVrLDz8V1tvFP-KUEg.ttf","500":"http://fonts.gstatic.com/s/poppins/v20/pxiByp8kv8JHgFVrLGT9V1tvFP-KUEg.ttf","600":"http://fonts.gstatic.com/s/poppins/v20/pxiByp8kv8JHgFVrLEj6V1tvFP-KUEg.ttf","700":"http://fonts.gstatic.com/s/poppins/v20/pxiByp8kv8JHgFVrLCz7V1tvFP-KUEg.ttf","800":"http://fonts.gstatic.com/s/poppins/v20/pxiByp8kv8JHgFVrLDD4V1tvFP-KUEg.ttf","900":"http://fonts.gstatic.com/s/poppins/v20/pxiByp8kv8JHgFVrLBT5V1tvFP-KUEg.ttf","100italic":"http://fonts.gstatic.com/s/poppins/v20/pxiAyp8kv8JHgFVrJJLmE3tFOvODSVFF.ttf","200italic":"http://fonts.gstatic.com/s/poppins/v20/pxiDyp8kv8JHgFVrJJLmv1plEN2PQEhcqw.ttf","300italic":"http://fonts.gstatic.com/s/poppins/v20/pxiDyp8kv8JHgFVrJJLm21llEN2PQEhcqw.ttf","regular":"http://fonts.gstatic.com/s/poppins/v20/pxiEyp8kv8JHgFVrFJDUc1NECPY.ttf","italic":"http://fonts.gstatic.com/s/poppins/v20/pxiGyp8kv8JHgFVrJJLed3FBGPaTSQ.ttf","500italic":"http://fonts.gstatic.com/s/poppins/v20/pxiDyp8kv8JHgFVrJJLmg1hlEN2PQEhcqw.ttf","600italic":"http://fonts.gstatic.com/s/poppins/v20/pxiDyp8kv8JHgFVrJJLmr19lEN2PQEhcqw.ttf","700italic":"http://fonts.gstatic.com/s/poppins/v20/pxiDyp8kv8JHgFVrJJLmy15lEN2PQEhcqw.ttf","800italic":"http://fonts.gstatic.com/s/poppins/v20/pxiDyp8kv8JHgFVrJJLm111lEN2PQEhcqw.ttf","900italic":"http://fonts.gstatic.com/s/poppins/v20/pxiDyp8kv8JHgFVrJJLm81xlEN2PQEhcqw.ttf"},"category":"sans-serif","kind":"webfonts#webfont"}, type: 'fontselect', options: []},
                           },
                           {font_style: {value: '', type: 'select', options: ['normal','italic','oblique','initial','inherit']},
                           },
                           {font_weight: {value: '', type: 'select', options: [100,200,300,400,500,600,700,800,900]},
                           },
                           {text_transform: {value: '', type: 'select', options: ['none','capitalize','uppercase','lowercase','initial','inherit']},
                           },
                           {letter_spacing: {active: false, type: 'range', value: 'auto', units: '', unit_options: ['px'],  max: 124, min: 0, parentlabel: 'sizing_label'},
                           },
                           {line_height: {active: false, type: 'range', value: 'auto', units: '', unit_options: ['px'],  max: 124, min: 0, parentlabel: 'sizing_label'}
                            },
                            {
								colour: {
									active: false,
									value: '#000000',
									type: 'color'
								},
							},
						],
						h4: [
							{font_size: {active: false, type: 'range', value: 'auto', units: '', unit_options: ['px'],  max: 124, min: 0, parentlabel: 'sizing_label'},
                           },
                           {font_family: {value: {"family":"Poppins","variants":["100","100italic","200","200italic","300","300italic","regular","italic","500","500italic","600","600italic","700","700italic","800","800italic","900","900italic"],"subsets":["devanagari","latin","latin-ext"],"version":"v20","lastModified":"2022-09-22","files":{"100":"http://fonts.gstatic.com/s/poppins/v20/pxiGyp8kv8JHgFVrLPTed3FBGPaTSQ.ttf","200":"http://fonts.gstatic.com/s/poppins/v20/pxiByp8kv8JHgFVrLFj_V1tvFP-KUEg.ttf","300":"http://fonts.gstatic.com/s/poppins/v20/pxiByp8kv8JHgFVrLDz8V1tvFP-KUEg.ttf","500":"http://fonts.gstatic.com/s/poppins/v20/pxiByp8kv8JHgFVrLGT9V1tvFP-KUEg.ttf","600":"http://fonts.gstatic.com/s/poppins/v20/pxiByp8kv8JHgFVrLEj6V1tvFP-KUEg.ttf","700":"http://fonts.gstatic.com/s/poppins/v20/pxiByp8kv8JHgFVrLCz7V1tvFP-KUEg.ttf","800":"http://fonts.gstatic.com/s/poppins/v20/pxiByp8kv8JHgFVrLDD4V1tvFP-KUEg.ttf","900":"http://fonts.gstatic.com/s/poppins/v20/pxiByp8kv8JHgFVrLBT5V1tvFP-KUEg.ttf","100italic":"http://fonts.gstatic.com/s/poppins/v20/pxiAyp8kv8JHgFVrJJLmE3tFOvODSVFF.ttf","200italic":"http://fonts.gstatic.com/s/poppins/v20/pxiDyp8kv8JHgFVrJJLmv1plEN2PQEhcqw.ttf","300italic":"http://fonts.gstatic.com/s/poppins/v20/pxiDyp8kv8JHgFVrJJLm21llEN2PQEhcqw.ttf","regular":"http://fonts.gstatic.com/s/poppins/v20/pxiEyp8kv8JHgFVrFJDUc1NECPY.ttf","italic":"http://fonts.gstatic.com/s/poppins/v20/pxiGyp8kv8JHgFVrJJLed3FBGPaTSQ.ttf","500italic":"http://fonts.gstatic.com/s/poppins/v20/pxiDyp8kv8JHgFVrJJLmg1hlEN2PQEhcqw.ttf","600italic":"http://fonts.gstatic.com/s/poppins/v20/pxiDyp8kv8JHgFVrJJLmr19lEN2PQEhcqw.ttf","700italic":"http://fonts.gstatic.com/s/poppins/v20/pxiDyp8kv8JHgFVrJJLmy15lEN2PQEhcqw.ttf","800italic":"http://fonts.gstatic.com/s/poppins/v20/pxiDyp8kv8JHgFVrJJLm111lEN2PQEhcqw.ttf","900italic":"http://fonts.gstatic.com/s/poppins/v20/pxiDyp8kv8JHgFVrJJLm81xlEN2PQEhcqw.ttf"},"category":"sans-serif","kind":"webfonts#webfont"}, type: 'fontselect', options: []},
                           },
                           {font_style: {value: '', type: 'select', options: ['normal','italic','oblique','initial','inherit']},
                           },
                           {font_weight: {value: '', type: 'select', options: [100,200,300,400,500,600,700,800,900]},
                           },
                           {text_transform: {value: '', type: 'select', options: ['none','capitalize','uppercase','lowercase','initial','inherit']},
                           },
                           {letter_spacing: {active: false, type: 'range', value: 'auto', units: '', unit_options: ['px'],  max: 124, min: 0, parentlabel: 'sizing_label'},
                           },
                           {line_height: {active: false, type: 'range', value: 'auto', units: '', unit_options: ['px'],  max: 124, min: 0, parentlabel: 'sizing_label'}
                            },
                            {
								colour: {
									active: false,
									value: '#000000',
									type: 'color'
								},
							},
						],
						h5: [
							{font_size: {active: false, type: 'range', value: 'auto', units: '', unit_options: ['px'],  max: 124, min: 0, parentlabel: 'sizing_label'},
                           },
                           {font_family: {value: {"family":"Poppins","variants":["100","100italic","200","200italic","300","300italic","regular","italic","500","500italic","600","600italic","700","700italic","800","800italic","900","900italic"],"subsets":["devanagari","latin","latin-ext"],"version":"v20","lastModified":"2022-09-22","files":{"100":"http://fonts.gstatic.com/s/poppins/v20/pxiGyp8kv8JHgFVrLPTed3FBGPaTSQ.ttf","200":"http://fonts.gstatic.com/s/poppins/v20/pxiByp8kv8JHgFVrLFj_V1tvFP-KUEg.ttf","300":"http://fonts.gstatic.com/s/poppins/v20/pxiByp8kv8JHgFVrLDz8V1tvFP-KUEg.ttf","500":"http://fonts.gstatic.com/s/poppins/v20/pxiByp8kv8JHgFVrLGT9V1tvFP-KUEg.ttf","600":"http://fonts.gstatic.com/s/poppins/v20/pxiByp8kv8JHgFVrLEj6V1tvFP-KUEg.ttf","700":"http://fonts.gstatic.com/s/poppins/v20/pxiByp8kv8JHgFVrLCz7V1tvFP-KUEg.ttf","800":"http://fonts.gstatic.com/s/poppins/v20/pxiByp8kv8JHgFVrLDD4V1tvFP-KUEg.ttf","900":"http://fonts.gstatic.com/s/poppins/v20/pxiByp8kv8JHgFVrLBT5V1tvFP-KUEg.ttf","100italic":"http://fonts.gstatic.com/s/poppins/v20/pxiAyp8kv8JHgFVrJJLmE3tFOvODSVFF.ttf","200italic":"http://fonts.gstatic.com/s/poppins/v20/pxiDyp8kv8JHgFVrJJLmv1plEN2PQEhcqw.ttf","300italic":"http://fonts.gstatic.com/s/poppins/v20/pxiDyp8kv8JHgFVrJJLm21llEN2PQEhcqw.ttf","regular":"http://fonts.gstatic.com/s/poppins/v20/pxiEyp8kv8JHgFVrFJDUc1NECPY.ttf","italic":"http://fonts.gstatic.com/s/poppins/v20/pxiGyp8kv8JHgFVrJJLed3FBGPaTSQ.ttf","500italic":"http://fonts.gstatic.com/s/poppins/v20/pxiDyp8kv8JHgFVrJJLmg1hlEN2PQEhcqw.ttf","600italic":"http://fonts.gstatic.com/s/poppins/v20/pxiDyp8kv8JHgFVrJJLmr19lEN2PQEhcqw.ttf","700italic":"http://fonts.gstatic.com/s/poppins/v20/pxiDyp8kv8JHgFVrJJLmy15lEN2PQEhcqw.ttf","800italic":"http://fonts.gstatic.com/s/poppins/v20/pxiDyp8kv8JHgFVrJJLm111lEN2PQEhcqw.ttf","900italic":"http://fonts.gstatic.com/s/poppins/v20/pxiDyp8kv8JHgFVrJJLm81xlEN2PQEhcqw.ttf"},"category":"sans-serif","kind":"webfonts#webfont"}, type: 'fontselect', options: []},
                           },
                           {font_style: {value: '', type: 'select', options: ['normal','italic','oblique','initial','inherit']},
                           },
                           {font_weight: {value: '', type: 'select', options: [100,200,300,400,500,600,700,800,900]},
                           },
                           {text_transform: {value: '', type: 'select', options: ['none','capitalize','uppercase','lowercase','initial','inherit']},
                           },
                           {letter_spacing: {active: false, type: 'range', value: 'auto', units: '', unit_options: ['px'],  max: 124, min: 0, parentlabel: 'sizing_label'},
                           },
                           {line_height: {active: false, type: 'range', value: 'auto', units: '', unit_options: ['px'],  max: 124, min: 0, parentlabel: 'sizing_label'}
                            },
                            {
								colour: {
									active: false,
									value: '#000000',
									type: 'color'
								},
							},
						],
						h6: [
							{font_size: {active: false, type: 'range', value: 'auto', units: '', unit_options: ['px'],  max: 124, min: 0, parentlabel: 'sizing_label'},
                           },
                           {font_family: {value: {"family":"Poppins","variants":["100","100italic","200","200italic","300","300italic","regular","italic","500","500italic","600","600italic","700","700italic","800","800italic","900","900italic"],"subsets":["devanagari","latin","latin-ext"],"version":"v20","lastModified":"2022-09-22","files":{"100":"http://fonts.gstatic.com/s/poppins/v20/pxiGyp8kv8JHgFVrLPTed3FBGPaTSQ.ttf","200":"http://fonts.gstatic.com/s/poppins/v20/pxiByp8kv8JHgFVrLFj_V1tvFP-KUEg.ttf","300":"http://fonts.gstatic.com/s/poppins/v20/pxiByp8kv8JHgFVrLDz8V1tvFP-KUEg.ttf","500":"http://fonts.gstatic.com/s/poppins/v20/pxiByp8kv8JHgFVrLGT9V1tvFP-KUEg.ttf","600":"http://fonts.gstatic.com/s/poppins/v20/pxiByp8kv8JHgFVrLEj6V1tvFP-KUEg.ttf","700":"http://fonts.gstatic.com/s/poppins/v20/pxiByp8kv8JHgFVrLCz7V1tvFP-KUEg.ttf","800":"http://fonts.gstatic.com/s/poppins/v20/pxiByp8kv8JHgFVrLDD4V1tvFP-KUEg.ttf","900":"http://fonts.gstatic.com/s/poppins/v20/pxiByp8kv8JHgFVrLBT5V1tvFP-KUEg.ttf","100italic":"http://fonts.gstatic.com/s/poppins/v20/pxiAyp8kv8JHgFVrJJLmE3tFOvODSVFF.ttf","200italic":"http://fonts.gstatic.com/s/poppins/v20/pxiDyp8kv8JHgFVrJJLmv1plEN2PQEhcqw.ttf","300italic":"http://fonts.gstatic.com/s/poppins/v20/pxiDyp8kv8JHgFVrJJLm21llEN2PQEhcqw.ttf","regular":"http://fonts.gstatic.com/s/poppins/v20/pxiEyp8kv8JHgFVrFJDUc1NECPY.ttf","italic":"http://fonts.gstatic.com/s/poppins/v20/pxiGyp8kv8JHgFVrJJLed3FBGPaTSQ.ttf","500italic":"http://fonts.gstatic.com/s/poppins/v20/pxiDyp8kv8JHgFVrJJLmg1hlEN2PQEhcqw.ttf","600italic":"http://fonts.gstatic.com/s/poppins/v20/pxiDyp8kv8JHgFVrJJLmr19lEN2PQEhcqw.ttf","700italic":"http://fonts.gstatic.com/s/poppins/v20/pxiDyp8kv8JHgFVrJJLmy15lEN2PQEhcqw.ttf","800italic":"http://fonts.gstatic.com/s/poppins/v20/pxiDyp8kv8JHgFVrJJLm111lEN2PQEhcqw.ttf","900italic":"http://fonts.gstatic.com/s/poppins/v20/pxiDyp8kv8JHgFVrJJLm81xlEN2PQEhcqw.ttf"},"category":"sans-serif","kind":"webfonts#webfont"}, type: 'fontselect', options: []},
                           },
                           {font_style: {value: '', type: 'select', options: ['normal','italic','oblique','initial','inherit']},
                           },
                           {font_weight: {value: '', type: 'select', options: [100,200,300,400,500,600,700,800,900]},
                           },
                           {text_transform: {value: '', type: 'select', options: ['none','capitalize','uppercase','lowercase','initial','inherit']},
                           },
                           {letter_spacing: {active: false, type: 'range', value: 'auto', units: '', unit_options: ['px'],  max: 124, min: 0, parentlabel: 'sizing_label'},
                           },
                           {line_height: {active: false, type: 'range', value: 'auto', units: '', unit_options: ['px'],  max: 124, min: 0, parentlabel: 'sizing_label'}
                            },
                            {
								colour: {
									active: false,
									value: '#000000',
									type: 'color'
								},
							},
						],
					},
				},
				{body_text: 
					{
						paragraph: [
							{font_size: {active: false, type: 'range', value: 'auto', units: '', unit_options: ['px'],  max: 124, min: 0, parentlabel: 'sizing_label'},
                           },
                           {font_family: {value: {"family":"Poppins","variants":["100","100italic","200","200italic","300","300italic","regular","italic","500","500italic","600","600italic","700","700italic","800","800italic","900","900italic"],"subsets":["devanagari","latin","latin-ext"],"version":"v20","lastModified":"2022-09-22","files":{"100":"http://fonts.gstatic.com/s/poppins/v20/pxiGyp8kv8JHgFVrLPTed3FBGPaTSQ.ttf","200":"http://fonts.gstatic.com/s/poppins/v20/pxiByp8kv8JHgFVrLFj_V1tvFP-KUEg.ttf","300":"http://fonts.gstatic.com/s/poppins/v20/pxiByp8kv8JHgFVrLDz8V1tvFP-KUEg.ttf","500":"http://fonts.gstatic.com/s/poppins/v20/pxiByp8kv8JHgFVrLGT9V1tvFP-KUEg.ttf","600":"http://fonts.gstatic.com/s/poppins/v20/pxiByp8kv8JHgFVrLEj6V1tvFP-KUEg.ttf","700":"http://fonts.gstatic.com/s/poppins/v20/pxiByp8kv8JHgFVrLCz7V1tvFP-KUEg.ttf","800":"http://fonts.gstatic.com/s/poppins/v20/pxiByp8kv8JHgFVrLDD4V1tvFP-KUEg.ttf","900":"http://fonts.gstatic.com/s/poppins/v20/pxiByp8kv8JHgFVrLBT5V1tvFP-KUEg.ttf","100italic":"http://fonts.gstatic.com/s/poppins/v20/pxiAyp8kv8JHgFVrJJLmE3tFOvODSVFF.ttf","200italic":"http://fonts.gstatic.com/s/poppins/v20/pxiDyp8kv8JHgFVrJJLmv1plEN2PQEhcqw.ttf","300italic":"http://fonts.gstatic.com/s/poppins/v20/pxiDyp8kv8JHgFVrJJLm21llEN2PQEhcqw.ttf","regular":"http://fonts.gstatic.com/s/poppins/v20/pxiEyp8kv8JHgFVrFJDUc1NECPY.ttf","italic":"http://fonts.gstatic.com/s/poppins/v20/pxiGyp8kv8JHgFVrJJLed3FBGPaTSQ.ttf","500italic":"http://fonts.gstatic.com/s/poppins/v20/pxiDyp8kv8JHgFVrJJLmg1hlEN2PQEhcqw.ttf","600italic":"http://fonts.gstatic.com/s/poppins/v20/pxiDyp8kv8JHgFVrJJLmr19lEN2PQEhcqw.ttf","700italic":"http://fonts.gstatic.com/s/poppins/v20/pxiDyp8kv8JHgFVrJJLmy15lEN2PQEhcqw.ttf","800italic":"http://fonts.gstatic.com/s/poppins/v20/pxiDyp8kv8JHgFVrJJLm111lEN2PQEhcqw.ttf","900italic":"http://fonts.gstatic.com/s/poppins/v20/pxiDyp8kv8JHgFVrJJLm81xlEN2PQEhcqw.ttf"},"category":"sans-serif","kind":"webfonts#webfont"}, type: 'fontselect', options: []},
                           },
                           {font_style: {value: '', type: 'select', options: ['normal','italic','oblique','initial','inherit']},
                           },
                           {font_weight: {value: '', type: 'select', options: [100,200,300,400,500,600,700,800,900]},
                           },
                           {text_transform: {value: '', type: 'select', options: ['none','capitalize','uppercase','lowercase','initial','inherit']},
                           },
                           {letter_spacing: {active: false, type: 'range', value: 'auto', units: '', unit_options: ['px'],  max: 124, min: 0, parentlabel: 'sizing_label'},
                           },
                           {line_height: {active: false, type: 'range', value: 'auto', units: '', unit_options: ['px'],  max: 124, min: 0, parentlabel: 'sizing_label'}
                            },
                            {
								colour: {
									active: false,
									value: '#000000',
									type: 'color'
								},
							},
						],
						links: [
							{font_size: {active: false, type: 'range', value: 'auto', units: '', unit_options: ['px'],  max: 124, min: 0, parentlabel: 'sizing_label'},
                           },
                           {font_family: {value: {"family":"Poppins","variants":["100","100italic","200","200italic","300","300italic","regular","italic","500","500italic","600","600italic","700","700italic","800","800italic","900","900italic"],"subsets":["devanagari","latin","latin-ext"],"version":"v20","lastModified":"2022-09-22","files":{"100":"http://fonts.gstatic.com/s/poppins/v20/pxiGyp8kv8JHgFVrLPTed3FBGPaTSQ.ttf","200":"http://fonts.gstatic.com/s/poppins/v20/pxiByp8kv8JHgFVrLFj_V1tvFP-KUEg.ttf","300":"http://fonts.gstatic.com/s/poppins/v20/pxiByp8kv8JHgFVrLDz8V1tvFP-KUEg.ttf","500":"http://fonts.gstatic.com/s/poppins/v20/pxiByp8kv8JHgFVrLGT9V1tvFP-KUEg.ttf","600":"http://fonts.gstatic.com/s/poppins/v20/pxiByp8kv8JHgFVrLEj6V1tvFP-KUEg.ttf","700":"http://fonts.gstatic.com/s/poppins/v20/pxiByp8kv8JHgFVrLCz7V1tvFP-KUEg.ttf","800":"http://fonts.gstatic.com/s/poppins/v20/pxiByp8kv8JHgFVrLDD4V1tvFP-KUEg.ttf","900":"http://fonts.gstatic.com/s/poppins/v20/pxiByp8kv8JHgFVrLBT5V1tvFP-KUEg.ttf","100italic":"http://fonts.gstatic.com/s/poppins/v20/pxiAyp8kv8JHgFVrJJLmE3tFOvODSVFF.ttf","200italic":"http://fonts.gstatic.com/s/poppins/v20/pxiDyp8kv8JHgFVrJJLmv1plEN2PQEhcqw.ttf","300italic":"http://fonts.gstatic.com/s/poppins/v20/pxiDyp8kv8JHgFVrJJLm21llEN2PQEhcqw.ttf","regular":"http://fonts.gstatic.com/s/poppins/v20/pxiEyp8kv8JHgFVrFJDUc1NECPY.ttf","italic":"http://fonts.gstatic.com/s/poppins/v20/pxiGyp8kv8JHgFVrJJLed3FBGPaTSQ.ttf","500italic":"http://fonts.gstatic.com/s/poppins/v20/pxiDyp8kv8JHgFVrJJLmg1hlEN2PQEhcqw.ttf","600italic":"http://fonts.gstatic.com/s/poppins/v20/pxiDyp8kv8JHgFVrJJLmr19lEN2PQEhcqw.ttf","700italic":"http://fonts.gstatic.com/s/poppins/v20/pxiDyp8kv8JHgFVrJJLmy15lEN2PQEhcqw.ttf","800italic":"http://fonts.gstatic.com/s/poppins/v20/pxiDyp8kv8JHgFVrJJLm111lEN2PQEhcqw.ttf","900italic":"http://fonts.gstatic.com/s/poppins/v20/pxiDyp8kv8JHgFVrJJLm81xlEN2PQEhcqw.ttf"},"category":"sans-serif","kind":"webfonts#webfont"}, type: 'fontselect', options: []},
                           },
                           {font_style: {value: '', type: 'select', options: ['normal','italic','oblique','initial','inherit']},
                           },
                           {font_weight: {value: '', type: 'select', options: [100,200,300,400,500,600,700,800,900]},
                           },
                           {text_transform: {value: '', type: 'select', options: ['none','capitalize','uppercase','lowercase','initial','inherit']},
                           },
                           {letter_spacing: {active: false, type: 'range', value: 'auto', units: '', unit_options: ['px'],  max: 124, min: 0, parentlabel: 'sizing_label'},
                           },
                           {line_height: {active: false, type: 'range', value: 'auto', units: '', unit_options: ['px'],  max: 124, min: 0, parentlabel: 'sizing_label'}
                            },
                            {
								colour: {
									active: false,
									value: '#000000',
									type: 'color'
								},
							},
						],
						blockquote: [
							{font_size: {active: false, type: 'range', value: 'auto', units: '', unit_options: ['px'],  max: 124, min: 0, parentlabel: 'sizing_label'},
                           },
                           {font_family: {value: {"family":"Poppins","variants":["100","100italic","200","200italic","300","300italic","regular","italic","500","500italic","600","600italic","700","700italic","800","800italic","900","900italic"],"subsets":["devanagari","latin","latin-ext"],"version":"v20","lastModified":"2022-09-22","files":{"100":"http://fonts.gstatic.com/s/poppins/v20/pxiGyp8kv8JHgFVrLPTed3FBGPaTSQ.ttf","200":"http://fonts.gstatic.com/s/poppins/v20/pxiByp8kv8JHgFVrLFj_V1tvFP-KUEg.ttf","300":"http://fonts.gstatic.com/s/poppins/v20/pxiByp8kv8JHgFVrLDz8V1tvFP-KUEg.ttf","500":"http://fonts.gstatic.com/s/poppins/v20/pxiByp8kv8JHgFVrLGT9V1tvFP-KUEg.ttf","600":"http://fonts.gstatic.com/s/poppins/v20/pxiByp8kv8JHgFVrLEj6V1tvFP-KUEg.ttf","700":"http://fonts.gstatic.com/s/poppins/v20/pxiByp8kv8JHgFVrLCz7V1tvFP-KUEg.ttf","800":"http://fonts.gstatic.com/s/poppins/v20/pxiByp8kv8JHgFVrLDD4V1tvFP-KUEg.ttf","900":"http://fonts.gstatic.com/s/poppins/v20/pxiByp8kv8JHgFVrLBT5V1tvFP-KUEg.ttf","100italic":"http://fonts.gstatic.com/s/poppins/v20/pxiAyp8kv8JHgFVrJJLmE3tFOvODSVFF.ttf","200italic":"http://fonts.gstatic.com/s/poppins/v20/pxiDyp8kv8JHgFVrJJLmv1plEN2PQEhcqw.ttf","300italic":"http://fonts.gstatic.com/s/poppins/v20/pxiDyp8kv8JHgFVrJJLm21llEN2PQEhcqw.ttf","regular":"http://fonts.gstatic.com/s/poppins/v20/pxiEyp8kv8JHgFVrFJDUc1NECPY.ttf","italic":"http://fonts.gstatic.com/s/poppins/v20/pxiGyp8kv8JHgFVrJJLed3FBGPaTSQ.ttf","500italic":"http://fonts.gstatic.com/s/poppins/v20/pxiDyp8kv8JHgFVrJJLmg1hlEN2PQEhcqw.ttf","600italic":"http://fonts.gstatic.com/s/poppins/v20/pxiDyp8kv8JHgFVrJJLmr19lEN2PQEhcqw.ttf","700italic":"http://fonts.gstatic.com/s/poppins/v20/pxiDyp8kv8JHgFVrJJLmy15lEN2PQEhcqw.ttf","800italic":"http://fonts.gstatic.com/s/poppins/v20/pxiDyp8kv8JHgFVrJJLm111lEN2PQEhcqw.ttf","900italic":"http://fonts.gstatic.com/s/poppins/v20/pxiDyp8kv8JHgFVrJJLm81xlEN2PQEhcqw.ttf"},"category":"sans-serif","kind":"webfonts#webfont"}, type: 'fontselect', options: []},
                           },
                           {font_style: {value: '', type: 'select', options: ['normal','italic','oblique','initial','inherit']},
                           },
                           {font_weight: {value: '', type: 'select', options: [100,200,300,400,500,600,700,800,900]},
                           },
                           {text_transform: {value: '', type: 'select', options: ['none','capitalize','uppercase','lowercase','initial','inherit']},
                           },
                           {letter_spacing: {active: false, type: 'range', value: 'auto', units: '', unit_options: ['px'],  max: 124, min: 0, parentlabel: 'sizing_label'},
                           },
                           {line_height: {active: false, type: 'range', value: 'auto', units: '', unit_options: ['px'],  max: 124, min: 0, parentlabel: 'sizing_label'}
                            },
                            {
								colour: {
									active: false,
									value: '#000000',
									type: 'color'
								},
							},
							{
							margin: containerStyleObjects.margin
							},
							{
							padding: containerStyleObjects.padding
							},
						],
					},
				},
				{
					menu: {

					},
				},
				{cards: {
					_1_default: [
						{
								background_colour: {
										active: false,
										value: '#000000',
										type: 'color'
									},
							},
							
							{
							border_label: containerStyleObjects.border_label,
							},
							{
							border: containerStyleObjects.border
							},
							{
							border_color: containerStyleObjects.border_colour
							},
							{
							border_style: containerStyleObjects.border_style
							},
							{
							title__font_label: {active: false, type: 'label', text: 'Title Font Settings', parentname: 'border_label'},
							},
							{title__font_size: {active: false, type: 'range', value: 'auto', units: '', unit_options: ['px'],  max: 124, min: 0, parentlabel: 'sizing_label'},
                           	},
                            {
                           	title__font_family: {value: {"family":"Poppins","variants":["100","100italic","200","200italic","300","300italic","regular","italic","500","500italic","600","600italic","700","700italic","800","800italic","900","900italic"],"subsets":["devanagari","latin","latin-ext"],"version":"v20","lastModified":"2022-09-22","files":{"100":"http://fonts.gstatic.com/s/poppins/v20/pxiGyp8kv8JHgFVrLPTed3FBGPaTSQ.ttf","200":"http://fonts.gstatic.com/s/poppins/v20/pxiByp8kv8JHgFVrLFj_V1tvFP-KUEg.ttf","300":"http://fonts.gstatic.com/s/poppins/v20/pxiByp8kv8JHgFVrLDz8V1tvFP-KUEg.ttf","500":"http://fonts.gstatic.com/s/poppins/v20/pxiByp8kv8JHgFVrLGT9V1tvFP-KUEg.ttf","600":"http://fonts.gstatic.com/s/poppins/v20/pxiByp8kv8JHgFVrLEj6V1tvFP-KUEg.ttf","700":"http://fonts.gstatic.com/s/poppins/v20/pxiByp8kv8JHgFVrLCz7V1tvFP-KUEg.ttf","800":"http://fonts.gstatic.com/s/poppins/v20/pxiByp8kv8JHgFVrLDD4V1tvFP-KUEg.ttf","900":"http://fonts.gstatic.com/s/poppins/v20/pxiByp8kv8JHgFVrLBT5V1tvFP-KUEg.ttf","100italic":"http://fonts.gstatic.com/s/poppins/v20/pxiAyp8kv8JHgFVrJJLmE3tFOvODSVFF.ttf","200italic":"http://fonts.gstatic.com/s/poppins/v20/pxiDyp8kv8JHgFVrJJLmv1plEN2PQEhcqw.ttf","300italic":"http://fonts.gstatic.com/s/poppins/v20/pxiDyp8kv8JHgFVrJJLm21llEN2PQEhcqw.ttf","regular":"http://fonts.gstatic.com/s/poppins/v20/pxiEyp8kv8JHgFVrFJDUc1NECPY.ttf","italic":"http://fonts.gstatic.com/s/poppins/v20/pxiGyp8kv8JHgFVrJJLed3FBGPaTSQ.ttf","500italic":"http://fonts.gstatic.com/s/poppins/v20/pxiDyp8kv8JHgFVrJJLmg1hlEN2PQEhcqw.ttf","600italic":"http://fonts.gstatic.com/s/poppins/v20/pxiDyp8kv8JHgFVrJJLmr19lEN2PQEhcqw.ttf","700italic":"http://fonts.gstatic.com/s/poppins/v20/pxiDyp8kv8JHgFVrJJLmy15lEN2PQEhcqw.ttf","800italic":"http://fonts.gstatic.com/s/poppins/v20/pxiDyp8kv8JHgFVrJJLm111lEN2PQEhcqw.ttf","900italic":"http://fonts.gstatic.com/s/poppins/v20/pxiDyp8kv8JHgFVrJJLm81xlEN2PQEhcqw.ttf"},"category":"sans-serif","kind":"webfonts#webfont"}, type: 'fontselect', options: []},
                            },
                            {
                           	title__font_style: {value: '', type: 'select', options: ['normal','italic','oblique','initial','inherit']},
                            },
                            {
                           	title__font_weight: {value: '', type: 'select', options: [100,200,300,400,500,600,700,800,900]},
                            },
                           {
                           	title__text_transform: {value: '', type: 'select', options: ['none','capitalize','uppercase','lowercase','initial','inherit']},
                           },
                           {
                           	title__letter_spacing: {active: false, type: 'range', value: 'auto', units: '', unit_options: ['px'],  max: 124, min: 0, parentlabel: 'sizing_label'},
                           },
                           {
                           	title__line_height: {active: false, type: 'range', value: 'auto', units: '', unit_options: ['px'],  max: 124, min: 0, parentlabel: 'sizing_label'}
                            },
                            {
								title__colour: {
									active: false,
									value: '#000000',
									type: 'color'
								},
							},
							{
							body__font_label: {active: false, type: 'label', text: 'Body Font Settings', parentname: 'border_label'},
							},
							{body__font_size: {active: false, type: 'range', value: 'auto', units: '', unit_options: ['px'],  max: 124, min: 0, parentlabel: 'sizing_label'},
                           	},
                            {
                           	body__font_family: {value: {"family":"Poppins","variants":["100","100italic","200","200italic","300","300italic","regular","italic","500","500italic","600","600italic","700","700italic","800","800italic","900","900italic"],"subsets":["devanagari","latin","latin-ext"],"version":"v20","lastModified":"2022-09-22","files":{"100":"http://fonts.gstatic.com/s/poppins/v20/pxiGyp8kv8JHgFVrLPTed3FBGPaTSQ.ttf","200":"http://fonts.gstatic.com/s/poppins/v20/pxiByp8kv8JHgFVrLFj_V1tvFP-KUEg.ttf","300":"http://fonts.gstatic.com/s/poppins/v20/pxiByp8kv8JHgFVrLDz8V1tvFP-KUEg.ttf","500":"http://fonts.gstatic.com/s/poppins/v20/pxiByp8kv8JHgFVrLGT9V1tvFP-KUEg.ttf","600":"http://fonts.gstatic.com/s/poppins/v20/pxiByp8kv8JHgFVrLEj6V1tvFP-KUEg.ttf","700":"http://fonts.gstatic.com/s/poppins/v20/pxiByp8kv8JHgFVrLCz7V1tvFP-KUEg.ttf","800":"http://fonts.gstatic.com/s/poppins/v20/pxiByp8kv8JHgFVrLDD4V1tvFP-KUEg.ttf","900":"http://fonts.gstatic.com/s/poppins/v20/pxiByp8kv8JHgFVrLBT5V1tvFP-KUEg.ttf","100italic":"http://fonts.gstatic.com/s/poppins/v20/pxiAyp8kv8JHgFVrJJLmE3tFOvODSVFF.ttf","200italic":"http://fonts.gstatic.com/s/poppins/v20/pxiDyp8kv8JHgFVrJJLmv1plEN2PQEhcqw.ttf","300italic":"http://fonts.gstatic.com/s/poppins/v20/pxiDyp8kv8JHgFVrJJLm21llEN2PQEhcqw.ttf","regular":"http://fonts.gstatic.com/s/poppins/v20/pxiEyp8kv8JHgFVrFJDUc1NECPY.ttf","italic":"http://fonts.gstatic.com/s/poppins/v20/pxiGyp8kv8JHgFVrJJLed3FBGPaTSQ.ttf","500italic":"http://fonts.gstatic.com/s/poppins/v20/pxiDyp8kv8JHgFVrJJLmg1hlEN2PQEhcqw.ttf","600italic":"http://fonts.gstatic.com/s/poppins/v20/pxiDyp8kv8JHgFVrJJLmr19lEN2PQEhcqw.ttf","700italic":"http://fonts.gstatic.com/s/poppins/v20/pxiDyp8kv8JHgFVrJJLmy15lEN2PQEhcqw.ttf","800italic":"http://fonts.gstatic.com/s/poppins/v20/pxiDyp8kv8JHgFVrJJLm111lEN2PQEhcqw.ttf","900italic":"http://fonts.gstatic.com/s/poppins/v20/pxiDyp8kv8JHgFVrJJLm81xlEN2PQEhcqw.ttf"},"category":"sans-serif","kind":"webfonts#webfont"}, type: 'fontselect', options: []},
                            },
                            {
                           	body__font_style: {value: '', type: 'select', options: ['normal','italic','oblique','initial','inherit']},
                            },
                            {
                           	body__font_weight: {value: '', type: 'select', options: [100,200,300,400,500,600,700,800,900]},
                            },
                           {
                           	body__text_transform: {value: '', type: 'select', options: ['none','capitalize','uppercase','lowercase','initial','inherit']},
                           },
                           {
                           	body__letter_spacing: {active: false, type: 'range', value: 'auto', units: '', unit_options: ['px'],  max: 124, min: 0, parentlabel: 'sizing_label'},
                           },
                           {
                           	body__line_height: {active: false, type: 'range', value: 'auto', units: '', unit_options: ['px'],  max: 124, min: 0, parentlabel: 'sizing_label'}
                            },
                            {
							button_primary__font_label: {active: false, type: 'label', text: 'Primary Button Settings', parentname: 'border_label'},
							},
							{
								button_primary__background_colour: {
										active: false,
										value: '#000000',
										type: 'color'
									},
							},
							{
								button_primary__text_colour: {
									active: false,
									value: '#000000',
									type: 'color'
								},
							},
							{
							button_primary__border_label: containerStyleObjects.border_label,
							},
							{
							button_primary__border: containerStyleObjects.border
							},
							{
							button_primary__border_color: containerStyleObjects.border_colour
							},
							{
							button_primary__border_style: containerStyleObjects.border_style
							},
							 {
							button_secondary__font_label: {active: false, type: 'label', text: 'Primary Button Settings', parentname: 'border_label'},
							},
							{
								button_secondary__background_colour: {
										active: false,
										value: '#000000',
										type: 'color'
									},
							},
							{
								button_secondary__text_colour: {
									active: false,
									value: '#000000',
									type: 'color'
								},
							},
							{
							button_secondary__border_label: containerStyleObjects.border_label,
							},
							{
							button_secondary__border: containerStyleObjects.border
							},
							{
							button_secondary__border_color: containerStyleObjects.border_colour
							},
							{
							button_secondary__border_style: containerStyleObjects.border_style
							},
						],
					_2_product: [
						{
								background_colour: {
										active: false,
										value: '#000000',
										type: 'color'
									},
							},
							
							{
							border_label: containerStyleObjects.border_label,
							},
							{
							border: containerStyleObjects.border
							},
							{
							border_color: containerStyleObjects.border_colour
							},
							{
							border_style: containerStyleObjects.border_style
							},
							{
								border_radius: {
									active: false,
									type: 'numbergroup',
									left: null,
									right: null,
									top: null,
									bottom: null,
								},
							},
							{
							title__font_label: {active: false, type: 'label', text: 'Title Font Settings', parentname: 'border_label'},
							},
							{title__font_size: {active: false, type: 'range', value: 'auto', units: '', unit_options: ['px'],  max: 124, min: 0, parentlabel: 'sizing_label'},
                           	},
                            {
                           	title__font_family: {value: {"family":"Poppins","variants":["100","100italic","200","200italic","300","300italic","regular","italic","500","500italic","600","600italic","700","700italic","800","800italic","900","900italic"],"subsets":["devanagari","latin","latin-ext"],"version":"v20","lastModified":"2022-09-22","files":{"100":"http://fonts.gstatic.com/s/poppins/v20/pxiGyp8kv8JHgFVrLPTed3FBGPaTSQ.ttf","200":"http://fonts.gstatic.com/s/poppins/v20/pxiByp8kv8JHgFVrLFj_V1tvFP-KUEg.ttf","300":"http://fonts.gstatic.com/s/poppins/v20/pxiByp8kv8JHgFVrLDz8V1tvFP-KUEg.ttf","500":"http://fonts.gstatic.com/s/poppins/v20/pxiByp8kv8JHgFVrLGT9V1tvFP-KUEg.ttf","600":"http://fonts.gstatic.com/s/poppins/v20/pxiByp8kv8JHgFVrLEj6V1tvFP-KUEg.ttf","700":"http://fonts.gstatic.com/s/poppins/v20/pxiByp8kv8JHgFVrLCz7V1tvFP-KUEg.ttf","800":"http://fonts.gstatic.com/s/poppins/v20/pxiByp8kv8JHgFVrLDD4V1tvFP-KUEg.ttf","900":"http://fonts.gstatic.com/s/poppins/v20/pxiByp8kv8JHgFVrLBT5V1tvFP-KUEg.ttf","100italic":"http://fonts.gstatic.com/s/poppins/v20/pxiAyp8kv8JHgFVrJJLmE3tFOvODSVFF.ttf","200italic":"http://fonts.gstatic.com/s/poppins/v20/pxiDyp8kv8JHgFVrJJLmv1plEN2PQEhcqw.ttf","300italic":"http://fonts.gstatic.com/s/poppins/v20/pxiDyp8kv8JHgFVrJJLm21llEN2PQEhcqw.ttf","regular":"http://fonts.gstatic.com/s/poppins/v20/pxiEyp8kv8JHgFVrFJDUc1NECPY.ttf","italic":"http://fonts.gstatic.com/s/poppins/v20/pxiGyp8kv8JHgFVrJJLed3FBGPaTSQ.ttf","500italic":"http://fonts.gstatic.com/s/poppins/v20/pxiDyp8kv8JHgFVrJJLmg1hlEN2PQEhcqw.ttf","600italic":"http://fonts.gstatic.com/s/poppins/v20/pxiDyp8kv8JHgFVrJJLmr19lEN2PQEhcqw.ttf","700italic":"http://fonts.gstatic.com/s/poppins/v20/pxiDyp8kv8JHgFVrJJLmy15lEN2PQEhcqw.ttf","800italic":"http://fonts.gstatic.com/s/poppins/v20/pxiDyp8kv8JHgFVrJJLm111lEN2PQEhcqw.ttf","900italic":"http://fonts.gstatic.com/s/poppins/v20/pxiDyp8kv8JHgFVrJJLm81xlEN2PQEhcqw.ttf"},"category":"sans-serif","kind":"webfonts#webfont"}, type: 'fontselect', options: []},
                            },
                            {
                           	title__font_style: {value: '', type: 'select', options: ['normal','italic','oblique','initial','inherit']},
                            },
                            {
                           	title__font_weight: {value: '', type: 'select', options: [100,200,300,400,500,600,700,800,900]},
                            },
                           {
                           	title__text_transform: {value: '', type: 'select', options: ['none','capitalize','uppercase','lowercase','initial','inherit']},
                           },
                           {
                           	title__letter_spacing: {active: false, type: 'range', value: 'auto', units: '', unit_options: ['px'],  max: 124, min: 0, parentlabel: 'sizing_label'},
                           },
                           {
                           	title__line_height: {active: false, type: 'range', value: 'auto', units: '', unit_options: ['px'],  max: 124, min: 0, parentlabel: 'sizing_label'}
                            },
                            {
								title_colour: {
									active: false,
									value: '#000000',
									type: 'color'
								},
							},
							{
							body__font_label: {active: false, type: 'label', text: 'Body Font Settings', parentname: 'border_label'},
							},
							{body__font_size: {active: false, type: 'range', value: 'auto', units: '', unit_options: ['px'],  max: 124, min: 0, parentlabel: 'sizing_label'},
                           	},
                            {
                           	body__font_family: {value: {"family":"Poppins","variants":["100","100italic","200","200italic","300","300italic","regular","italic","500","500italic","600","600italic","700","700italic","800","800italic","900","900italic"],"subsets":["devanagari","latin","latin-ext"],"version":"v20","lastModified":"2022-09-22","files":{"100":"http://fonts.gstatic.com/s/poppins/v20/pxiGyp8kv8JHgFVrLPTed3FBGPaTSQ.ttf","200":"http://fonts.gstatic.com/s/poppins/v20/pxiByp8kv8JHgFVrLFj_V1tvFP-KUEg.ttf","300":"http://fonts.gstatic.com/s/poppins/v20/pxiByp8kv8JHgFVrLDz8V1tvFP-KUEg.ttf","500":"http://fonts.gstatic.com/s/poppins/v20/pxiByp8kv8JHgFVrLGT9V1tvFP-KUEg.ttf","600":"http://fonts.gstatic.com/s/poppins/v20/pxiByp8kv8JHgFVrLEj6V1tvFP-KUEg.ttf","700":"http://fonts.gstatic.com/s/poppins/v20/pxiByp8kv8JHgFVrLCz7V1tvFP-KUEg.ttf","800":"http://fonts.gstatic.com/s/poppins/v20/pxiByp8kv8JHgFVrLDD4V1tvFP-KUEg.ttf","900":"http://fonts.gstatic.com/s/poppins/v20/pxiByp8kv8JHgFVrLBT5V1tvFP-KUEg.ttf","100italic":"http://fonts.gstatic.com/s/poppins/v20/pxiAyp8kv8JHgFVrJJLmE3tFOvODSVFF.ttf","200italic":"http://fonts.gstatic.com/s/poppins/v20/pxiDyp8kv8JHgFVrJJLmv1plEN2PQEhcqw.ttf","300italic":"http://fonts.gstatic.com/s/poppins/v20/pxiDyp8kv8JHgFVrJJLm21llEN2PQEhcqw.ttf","regular":"http://fonts.gstatic.com/s/poppins/v20/pxiEyp8kv8JHgFVrFJDUc1NECPY.ttf","italic":"http://fonts.gstatic.com/s/poppins/v20/pxiGyp8kv8JHgFVrJJLed3FBGPaTSQ.ttf","500italic":"http://fonts.gstatic.com/s/poppins/v20/pxiDyp8kv8JHgFVrJJLmg1hlEN2PQEhcqw.ttf","600italic":"http://fonts.gstatic.com/s/poppins/v20/pxiDyp8kv8JHgFVrJJLmr19lEN2PQEhcqw.ttf","700italic":"http://fonts.gstatic.com/s/poppins/v20/pxiDyp8kv8JHgFVrJJLmy15lEN2PQEhcqw.ttf","800italic":"http://fonts.gstatic.com/s/poppins/v20/pxiDyp8kv8JHgFVrJJLm111lEN2PQEhcqw.ttf","900italic":"http://fonts.gstatic.com/s/poppins/v20/pxiDyp8kv8JHgFVrJJLm81xlEN2PQEhcqw.ttf"},"category":"sans-serif","kind":"webfonts#webfont"}, type: 'fontselect', options: []},
                            },
                            {
                           	body__font_style: {value: '', type: 'select', options: ['normal','italic','oblique','initial','inherit']},
                            },
                            {
                           	body__font_weight: {value: '', type: 'select', options: [100,200,300,400,500,600,700,800,900]},
                            },
                           {
                           	body__text_transform: {value: '', type: 'select', options: ['none','capitalize','uppercase','lowercase','initial','inherit']},
                           },
                           {
                           	body__letter_spacing: {active: false, type: 'range', value: 'auto', units: '', unit_options: ['px'],  max: 124, min: 0, parentlabel: 'sizing_label'},
                           },
                           {
                           	body__line_height: {active: false, type: 'range', value: 'auto', units: '', unit_options: ['px'],  max: 124, min: 0, parentlabel: 'sizing_label'}
                            },
                            {
							button__font_label: {active: false, type: 'label', text: 'Button Settings', parentname: 'border_label'},
							},
							{
								button__background_colour: {
										active: false,
										value: '#000000',
										type: 'color'
									},
							},
							{
								button__text_colour: {
									active: false,
									value: '#000000',
									type: 'color'
								},
							},
							{
							button__border_label: containerStyleObjects.border_label,
							},
							{
							button__border: containerStyleObjects.border
							},
							{
							button__border_color: containerStyleObjects.border_colour
							},
							{
							button__border_style: containerStyleObjects.border_style
							},
							{
							pricing_badge__label: {active: false, type: 'label', text: 'Pricing Badge', parentname: 'border_label'},
							},
							{
								pricing_badge__background_colour: {
										active: false,
										value: '#000000',
										type: 'color'
									},
							},
							{
								pricing_badge__text_colour: {
									active: false,
									value: '#000000',
									type: 'color'
								},
							},

					],
					_3_collection_category: [],
					_4_listing: [
						{
								background_colour: {
										active: false,
										value: '#000000',
										type: 'color'
									},
							},
							
							{
							border_label: containerStyleObjects.border_label,
							},
							{
							border: containerStyleObjects.border
							},
							{
							border_color: containerStyleObjects.border_colour
							},
							{
							border_style: containerStyleObjects.border_style
							},
							{
								border_radius: {
									active: false,
									type: 'numbergroup',
									left: null,
									right: null,
									top: null,
									bottom: null,
								},
							},
							{
							title_font_label: {active: false, type: 'label', text: 'Title Font Settings', parentname: 'border_label'},
							},
							{title__font_size: {active: false, type: 'range', value: 'auto', units: '', unit_options: ['px'],  max: 124, min: 0, parentlabel: 'sizing_label'},
                           	},
                            {
                           	title__font_family: {value: {"family":"Poppins","variants":["100","100italic","200","200italic","300","300italic","regular","italic","500","500italic","600","600italic","700","700italic","800","800italic","900","900italic"],"subsets":["devanagari","latin","latin-ext"],"version":"v20","lastModified":"2022-09-22","files":{"100":"http://fonts.gstatic.com/s/poppins/v20/pxiGyp8kv8JHgFVrLPTed3FBGPaTSQ.ttf","200":"http://fonts.gstatic.com/s/poppins/v20/pxiByp8kv8JHgFVrLFj_V1tvFP-KUEg.ttf","300":"http://fonts.gstatic.com/s/poppins/v20/pxiByp8kv8JHgFVrLDz8V1tvFP-KUEg.ttf","500":"http://fonts.gstatic.com/s/poppins/v20/pxiByp8kv8JHgFVrLGT9V1tvFP-KUEg.ttf","600":"http://fonts.gstatic.com/s/poppins/v20/pxiByp8kv8JHgFVrLEj6V1tvFP-KUEg.ttf","700":"http://fonts.gstatic.com/s/poppins/v20/pxiByp8kv8JHgFVrLCz7V1tvFP-KUEg.ttf","800":"http://fonts.gstatic.com/s/poppins/v20/pxiByp8kv8JHgFVrLDD4V1tvFP-KUEg.ttf","900":"http://fonts.gstatic.com/s/poppins/v20/pxiByp8kv8JHgFVrLBT5V1tvFP-KUEg.ttf","100italic":"http://fonts.gstatic.com/s/poppins/v20/pxiAyp8kv8JHgFVrJJLmE3tFOvODSVFF.ttf","200italic":"http://fonts.gstatic.com/s/poppins/v20/pxiDyp8kv8JHgFVrJJLmv1plEN2PQEhcqw.ttf","300italic":"http://fonts.gstatic.com/s/poppins/v20/pxiDyp8kv8JHgFVrJJLm21llEN2PQEhcqw.ttf","regular":"http://fonts.gstatic.com/s/poppins/v20/pxiEyp8kv8JHgFVrFJDUc1NECPY.ttf","italic":"http://fonts.gstatic.com/s/poppins/v20/pxiGyp8kv8JHgFVrJJLed3FBGPaTSQ.ttf","500italic":"http://fonts.gstatic.com/s/poppins/v20/pxiDyp8kv8JHgFVrJJLmg1hlEN2PQEhcqw.ttf","600italic":"http://fonts.gstatic.com/s/poppins/v20/pxiDyp8kv8JHgFVrJJLmr19lEN2PQEhcqw.ttf","700italic":"http://fonts.gstatic.com/s/poppins/v20/pxiDyp8kv8JHgFVrJJLmy15lEN2PQEhcqw.ttf","800italic":"http://fonts.gstatic.com/s/poppins/v20/pxiDyp8kv8JHgFVrJJLm111lEN2PQEhcqw.ttf","900italic":"http://fonts.gstatic.com/s/poppins/v20/pxiDyp8kv8JHgFVrJJLm81xlEN2PQEhcqw.ttf"},"category":"sans-serif","kind":"webfonts#webfont"}, type: 'fontselect', options: []},
                            },
                            {
                           	title__font_style: {value: '', type: 'select', options: ['normal','italic','oblique','initial','inherit']},
                            },
                            {
                           	title__font_weight: {value: '', type: 'select', options: [100,200,300,400,500,600,700,800,900]},
                            },
                           {
                           	title__text_transform: {value: '', type: 'select', options: ['none','capitalize','uppercase','lowercase','initial','inherit']},
                           },
                           {
                           	title__letter_spacing: {active: false, type: 'range', value: 'auto', units: '', unit_options: ['px'],  max: 124, min: 0, parentlabel: 'sizing_label'},
                           },
                           {
                           	title__line_height: {active: false, type: 'range', value: 'auto', units: '', unit_options: ['px'],  max: 124, min: 0, parentlabel: 'sizing_label'}
                            },
                            {
								title__colour: {
									active: false,
									value: '#000000',
									type: 'color'
								},
							},
							{
							body__font_label: {active: false, type: 'label', text: 'Body Font Settings', parentname: 'border_label'},
							},
							{body__font_size: {active: false, type: 'range', value: 'auto', units: '', unit_options: ['px'],  max: 124, min: 0, parentlabel: 'sizing_label'},
                           	},
                            {
                           	body__font_family: {value: {"family":"Poppins","variants":["100","100italic","200","200italic","300","300italic","regular","italic","500","500italic","600","600italic","700","700italic","800","800italic","900","900italic"],"subsets":["devanagari","latin","latin-ext"],"version":"v20","lastModified":"2022-09-22","files":{"100":"http://fonts.gstatic.com/s/poppins/v20/pxiGyp8kv8JHgFVrLPTed3FBGPaTSQ.ttf","200":"http://fonts.gstatic.com/s/poppins/v20/pxiByp8kv8JHgFVrLFj_V1tvFP-KUEg.ttf","300":"http://fonts.gstatic.com/s/poppins/v20/pxiByp8kv8JHgFVrLDz8V1tvFP-KUEg.ttf","500":"http://fonts.gstatic.com/s/poppins/v20/pxiByp8kv8JHgFVrLGT9V1tvFP-KUEg.ttf","600":"http://fonts.gstatic.com/s/poppins/v20/pxiByp8kv8JHgFVrLEj6V1tvFP-KUEg.ttf","700":"http://fonts.gstatic.com/s/poppins/v20/pxiByp8kv8JHgFVrLCz7V1tvFP-KUEg.ttf","800":"http://fonts.gstatic.com/s/poppins/v20/pxiByp8kv8JHgFVrLDD4V1tvFP-KUEg.ttf","900":"http://fonts.gstatic.com/s/poppins/v20/pxiByp8kv8JHgFVrLBT5V1tvFP-KUEg.ttf","100italic":"http://fonts.gstatic.com/s/poppins/v20/pxiAyp8kv8JHgFVrJJLmE3tFOvODSVFF.ttf","200italic":"http://fonts.gstatic.com/s/poppins/v20/pxiDyp8kv8JHgFVrJJLmv1plEN2PQEhcqw.ttf","300italic":"http://fonts.gstatic.com/s/poppins/v20/pxiDyp8kv8JHgFVrJJLm21llEN2PQEhcqw.ttf","regular":"http://fonts.gstatic.com/s/poppins/v20/pxiEyp8kv8JHgFVrFJDUc1NECPY.ttf","italic":"http://fonts.gstatic.com/s/poppins/v20/pxiGyp8kv8JHgFVrJJLed3FBGPaTSQ.ttf","500italic":"http://fonts.gstatic.com/s/poppins/v20/pxiDyp8kv8JHgFVrJJLmg1hlEN2PQEhcqw.ttf","600italic":"http://fonts.gstatic.com/s/poppins/v20/pxiDyp8kv8JHgFVrJJLmr19lEN2PQEhcqw.ttf","700italic":"http://fonts.gstatic.com/s/poppins/v20/pxiDyp8kv8JHgFVrJJLmy15lEN2PQEhcqw.ttf","800italic":"http://fonts.gstatic.com/s/poppins/v20/pxiDyp8kv8JHgFVrJJLm111lEN2PQEhcqw.ttf","900italic":"http://fonts.gstatic.com/s/poppins/v20/pxiDyp8kv8JHgFVrJJLm81xlEN2PQEhcqw.ttf"},"category":"sans-serif","kind":"webfonts#webfont"}, type: 'fontselect', options: []},
                            },
                            {
                           	body__font_style: {value: '', type: 'select', options: ['normal','italic','oblique','initial','inherit']},
                            },
                            {
                           	body__font_weight: {value: '', type: 'select', options: [100,200,300,400,500,600,700,800,900]},
                            },
                           {
                           	body__text_transform: {value: '', type: 'select', options: ['none','capitalize','uppercase','lowercase','initial','inherit']},
                           },
                           {
                           	body__letter_spacing: {active: false, type: 'range', value: 'auto', units: '', unit_options: ['px'],  max: 124, min: 0, parentlabel: 'sizing_label'},
                           },
                           {
                           	body__line_height: {active: false, type: 'range', value: 'auto', units: '', unit_options: ['px'],  max: 124, min: 0, parentlabel: 'sizing_label'}
                            },
                            {
							button__font_label: {active: false, type: 'label', text: 'Button Settings', parentname: 'border_label'},
							},
							{
								button__background_colour: {
										active: false,
										value: '#000000',
										type: 'color'
									},
							},
							{
								button__text_colour: {
									active: false,
									value: '#000000',
									type: 'color'
								},
							},
							{
								button__border_label: containerStyleObjects.border_label,
							},
							{
								button__border: containerStyleObjects.border
							},
							{
								button__border_color: containerStyleObjects.border_colour
							},
							{
								button__border_style: containerStyleObjects.border_style
							},
							{
								listing_pin__label: {active: false, type: 'label', text: 'Listing Pin', parentname: 'border_label'},
							},
							{
								listing_pin__background_colour: {
										active: false,
										value: '#000000',
										type: 'color'
									},
							},
							{
								listing_pin_icon__colour: {
									active: false,
									value: '#000000',
									type: 'color'
								},
							},
							{
								listing__badge_label: {active: false, type: 'label', text: 'Listing Badge', parentname: 'border_label'},
							},
							{
								listing_badge__background_colour: {
										active: false,
										value: '#000000',
										type: 'color'
									},
							},
							{
								listing_badge__text_colour: {
									active: false,
									value: '#000000',
									type: 'color'
								},
							},


					],
				},
			},
			{buttons: 
					{
						button_primary: [
							{
								background_colour: {
										active: false,
										value: '#000000',
										type: 'color'
									},
							},
							{
								text_colour: {
									active: false,
									value: '#000000',
									type: 'color'
								},
							},
							{
							border_label: containerStyleObjects.border_label,
							},
							{
							border: containerStyleObjects.border
							},
							{
							border_color: containerStyleObjects.border_colour
							},
							{
							border_style: containerStyleObjects.border_style
							},
							{
								font_label: {active: false, type: 'label', text: 'Button Font Settings', parentname: 'border_label'},
							},
							{font_size: {active: false, type: 'range', value: 'auto', units: '', unit_options: ['px'],  max: 124, min: 0, parentlabel: 'sizing_label'},
                           	},
                            {
                           	font_family: {value: {"family":"Poppins","variants":["100","100italic","200","200italic","300","300italic","regular","italic","500","500italic","600","600italic","700","700italic","800","800italic","900","900italic"],"subsets":["devanagari","latin","latin-ext"],"version":"v20","lastModified":"2022-09-22","files":{"100":"http://fonts.gstatic.com/s/poppins/v20/pxiGyp8kv8JHgFVrLPTed3FBGPaTSQ.ttf","200":"http://fonts.gstatic.com/s/poppins/v20/pxiByp8kv8JHgFVrLFj_V1tvFP-KUEg.ttf","300":"http://fonts.gstatic.com/s/poppins/v20/pxiByp8kv8JHgFVrLDz8V1tvFP-KUEg.ttf","500":"http://fonts.gstatic.com/s/poppins/v20/pxiByp8kv8JHgFVrLGT9V1tvFP-KUEg.ttf","600":"http://fonts.gstatic.com/s/poppins/v20/pxiByp8kv8JHgFVrLEj6V1tvFP-KUEg.ttf","700":"http://fonts.gstatic.com/s/poppins/v20/pxiByp8kv8JHgFVrLCz7V1tvFP-KUEg.ttf","800":"http://fonts.gstatic.com/s/poppins/v20/pxiByp8kv8JHgFVrLDD4V1tvFP-KUEg.ttf","900":"http://fonts.gstatic.com/s/poppins/v20/pxiByp8kv8JHgFVrLBT5V1tvFP-KUEg.ttf","100italic":"http://fonts.gstatic.com/s/poppins/v20/pxiAyp8kv8JHgFVrJJLmE3tFOvODSVFF.ttf","200italic":"http://fonts.gstatic.com/s/poppins/v20/pxiDyp8kv8JHgFVrJJLmv1plEN2PQEhcqw.ttf","300italic":"http://fonts.gstatic.com/s/poppins/v20/pxiDyp8kv8JHgFVrJJLm21llEN2PQEhcqw.ttf","regular":"http://fonts.gstatic.com/s/poppins/v20/pxiEyp8kv8JHgFVrFJDUc1NECPY.ttf","italic":"http://fonts.gstatic.com/s/poppins/v20/pxiGyp8kv8JHgFVrJJLed3FBGPaTSQ.ttf","500italic":"http://fonts.gstatic.com/s/poppins/v20/pxiDyp8kv8JHgFVrJJLmg1hlEN2PQEhcqw.ttf","600italic":"http://fonts.gstatic.com/s/poppins/v20/pxiDyp8kv8JHgFVrJJLmr19lEN2PQEhcqw.ttf","700italic":"http://fonts.gstatic.com/s/poppins/v20/pxiDyp8kv8JHgFVrJJLmy15lEN2PQEhcqw.ttf","800italic":"http://fonts.gstatic.com/s/poppins/v20/pxiDyp8kv8JHgFVrJJLm111lEN2PQEhcqw.ttf","900italic":"http://fonts.gstatic.com/s/poppins/v20/pxiDyp8kv8JHgFVrJJLm81xlEN2PQEhcqw.ttf"},"category":"sans-serif","kind":"webfonts#webfont"}, type: 'fontselect', options: []},
                            },
                            {
                           	font_style: {value: '', type: 'select', options: ['normal','italic','oblique','initial','inherit']},
                            },
                            {
                           	font_weight: {value: '', type: 'select', options: [100,200,300,400,500,600,700,800,900]},
                            },
                           {
                           	text_transform: {value: '', type: 'select', options: ['none','capitalize','uppercase','lowercase','initial','inherit']},
                           },
                           {
                           	letter_spacing: {active: false, type: 'range', value: 'auto', units: '', unit_options: ['px'],  max: 124, min: 0, parentlabel: 'sizing_label'},
                           },
                           {
                           	line_height: {active: false, type: 'range', value: 'auto', units: '', unit_options: ['px'],  max: 124, min: 0, parentlabel: 'sizing_label'}
                            }
						]
					},
				},
				{pagination: {
					alignment: [
							{
								horizontal_align: {active: false, type: 'radiogroup', isButton: true, value: 'left', options: ['left', 'center', 'right']}
							}
					],
					button: [
								{
								background_color: containerStyleObjects.border_colour
								},
								{
								border: containerStyleObjects.border
								},
								{
								border_color: containerStyleObjects.border_colour
								},
								{
								border_style: containerStyleObjects.border_style
								},
								{
									border_radius: {
										active: false,
										type: 'numbergroup',
										left: null,
										right: null,
										top: null,
										bottom: null,
									},
								},
							],
				},
			},
			{filters: {
					field: [
								{
								background_color: containerStyleObjects.border_colour
								},
								{
								border: containerStyleObjects.border
								},
								{
								border_color: containerStyleObjects.border_colour
								},
								{
								border_style: containerStyleObjects.border_style
								},
								{
									border_radius: {
										active: false,
										type: 'numbergroup',
										left: null,
										right: null,
										top: null,
										bottom: null,
									},
								},
							],
					button: [
								{
								background_color: containerStyleObjects.border_colour
								},
								{
								border: containerStyleObjects.border
								},
								{
								border_color: containerStyleObjects.border_colour
								},
								{
								border_style: containerStyleObjects.border_style
								},
								{
									border_radius: {
										active: false,
										type: 'numbergroup',
										left: null,
										right: null,
										top: null,
										bottom: null,
									},
								},
								{font_size: {active: false, type: 'range', value: 'auto', units: '', unit_options: ['px'],  max: 124, min: 0, parentlabel: 'sizing_label'},
	                           	},
	                            {
	                           	font_family: {value: {"family":"Poppins","variants":["100","100italic","200","200italic","300","300italic","regular","italic","500","500italic","600","600italic","700","700italic","800","800italic","900","900italic"],"subsets":["devanagari","latin","latin-ext"],"version":"v20","lastModified":"2022-09-22","files":{"100":"http://fonts.gstatic.com/s/poppins/v20/pxiGyp8kv8JHgFVrLPTed3FBGPaTSQ.ttf","200":"http://fonts.gstatic.com/s/poppins/v20/pxiByp8kv8JHgFVrLFj_V1tvFP-KUEg.ttf","300":"http://fonts.gstatic.com/s/poppins/v20/pxiByp8kv8JHgFVrLDz8V1tvFP-KUEg.ttf","500":"http://fonts.gstatic.com/s/poppins/v20/pxiByp8kv8JHgFVrLGT9V1tvFP-KUEg.ttf","600":"http://fonts.gstatic.com/s/poppins/v20/pxiByp8kv8JHgFVrLEj6V1tvFP-KUEg.ttf","700":"http://fonts.gstatic.com/s/poppins/v20/pxiByp8kv8JHgFVrLCz7V1tvFP-KUEg.ttf","800":"http://fonts.gstatic.com/s/poppins/v20/pxiByp8kv8JHgFVrLDD4V1tvFP-KUEg.ttf","900":"http://fonts.gstatic.com/s/poppins/v20/pxiByp8kv8JHgFVrLBT5V1tvFP-KUEg.ttf","100italic":"http://fonts.gstatic.com/s/poppins/v20/pxiAyp8kv8JHgFVrJJLmE3tFOvODSVFF.ttf","200italic":"http://fonts.gstatic.com/s/poppins/v20/pxiDyp8kv8JHgFVrJJLmv1plEN2PQEhcqw.ttf","300italic":"http://fonts.gstatic.com/s/poppins/v20/pxiDyp8kv8JHgFVrJJLm21llEN2PQEhcqw.ttf","regular":"http://fonts.gstatic.com/s/poppins/v20/pxiEyp8kv8JHgFVrFJDUc1NECPY.ttf","italic":"http://fonts.gstatic.com/s/poppins/v20/pxiGyp8kv8JHgFVrJJLed3FBGPaTSQ.ttf","500italic":"http://fonts.gstatic.com/s/poppins/v20/pxiDyp8kv8JHgFVrJJLmg1hlEN2PQEhcqw.ttf","600italic":"http://fonts.gstatic.com/s/poppins/v20/pxiDyp8kv8JHgFVrJJLmr19lEN2PQEhcqw.ttf","700italic":"http://fonts.gstatic.com/s/poppins/v20/pxiDyp8kv8JHgFVrJJLmy15lEN2PQEhcqw.ttf","800italic":"http://fonts.gstatic.com/s/poppins/v20/pxiDyp8kv8JHgFVrJJLm111lEN2PQEhcqw.ttf","900italic":"http://fonts.gstatic.com/s/poppins/v20/pxiDyp8kv8JHgFVrJJLm81xlEN2PQEhcqw.ttf"},"category":"sans-serif","kind":"webfonts#webfont"}, type: 'fontselect', options: []},
	                            },
	                            {
	                           	font_style: {value: '', type: 'select', options: ['normal','italic','oblique','initial','inherit']},
	                            },
	                            {
	                           	font_weight: {value: '', type: 'select', options: [100,200,300,400,500,600,700,800,900]},
	                            },
	                           {
	                           	text_transform: {value: '', type: 'select', options: ['none','capitalize','uppercase','lowercase','initial','inherit']},
	                           },
	                           {
	                           	letter_spacing: {active: false, type: 'range', value: 'auto', units: '', unit_options: ['px'],  max: 124, min: 0, parentlabel: 'sizing_label'},
	                           },
	                           {
	                           	line_height: {active: false, type: 'range', value: 'auto', units: '', unit_options: ['px'],  max: 124, min: 0, parentlabel: 'sizing_label'}
	                            }
							],
				},
			},
			{search_bar:{
					field: [
								{
								background_color: containerStyleObjects.border_colour
								},
								{
								border: containerStyleObjects.border
								},
								{
								border_color: containerStyleObjects.border_colour
								},
								{
								border_style: containerStyleObjects.border_style
								},
								{
									border_radius: {
										active: false,
										type: 'numbergroup',
										left: null,
										right: null,
										top: null,
										bottom: null,
									},
								},
							],
					button: [
								{
								background_color: containerStyleObjects.border_colour
								},
								{
								border: containerStyleObjects.border
								},
								{
								border_color: containerStyleObjects.border_colour
								},
								{
								border_style: containerStyleObjects.border_style
								},
								{
									border_radius: {
										active: false,
										type: 'numbergroup',
										left: null,
										right: null,
										top: null,
										bottom: null,
									},
								},
								{font_size: {active: false, type: 'range', value: 'auto', units: '', unit_options: ['px'],  max: 124, min: 0, parentlabel: 'sizing_label'},
	                           	},
	                            {
	                           	font_family: {value: {"family":"Poppins","variants":["100","100italic","200","200italic","300","300italic","regular","italic","500","500italic","600","600italic","700","700italic","800","800italic","900","900italic"],"subsets":["devanagari","latin","latin-ext"],"version":"v20","lastModified":"2022-09-22","files":{"100":"http://fonts.gstatic.com/s/poppins/v20/pxiGyp8kv8JHgFVrLPTed3FBGPaTSQ.ttf","200":"http://fonts.gstatic.com/s/poppins/v20/pxiByp8kv8JHgFVrLFj_V1tvFP-KUEg.ttf","300":"http://fonts.gstatic.com/s/poppins/v20/pxiByp8kv8JHgFVrLDz8V1tvFP-KUEg.ttf","500":"http://fonts.gstatic.com/s/poppins/v20/pxiByp8kv8JHgFVrLGT9V1tvFP-KUEg.ttf","600":"http://fonts.gstatic.com/s/poppins/v20/pxiByp8kv8JHgFVrLEj6V1tvFP-KUEg.ttf","700":"http://fonts.gstatic.com/s/poppins/v20/pxiByp8kv8JHgFVrLCz7V1tvFP-KUEg.ttf","800":"http://fonts.gstatic.com/s/poppins/v20/pxiByp8kv8JHgFVrLDD4V1tvFP-KUEg.ttf","900":"http://fonts.gstatic.com/s/poppins/v20/pxiByp8kv8JHgFVrLBT5V1tvFP-KUEg.ttf","100italic":"http://fonts.gstatic.com/s/poppins/v20/pxiAyp8kv8JHgFVrJJLmE3tFOvODSVFF.ttf","200italic":"http://fonts.gstatic.com/s/poppins/v20/pxiDyp8kv8JHgFVrJJLmv1plEN2PQEhcqw.ttf","300italic":"http://fonts.gstatic.com/s/poppins/v20/pxiDyp8kv8JHgFVrJJLm21llEN2PQEhcqw.ttf","regular":"http://fonts.gstatic.com/s/poppins/v20/pxiEyp8kv8JHgFVrFJDUc1NECPY.ttf","italic":"http://fonts.gstatic.com/s/poppins/v20/pxiGyp8kv8JHgFVrJJLed3FBGPaTSQ.ttf","500italic":"http://fonts.gstatic.com/s/poppins/v20/pxiDyp8kv8JHgFVrJJLmg1hlEN2PQEhcqw.ttf","600italic":"http://fonts.gstatic.com/s/poppins/v20/pxiDyp8kv8JHgFVrJJLmr19lEN2PQEhcqw.ttf","700italic":"http://fonts.gstatic.com/s/poppins/v20/pxiDyp8kv8JHgFVrJJLmy15lEN2PQEhcqw.ttf","800italic":"http://fonts.gstatic.com/s/poppins/v20/pxiDyp8kv8JHgFVrJJLm111lEN2PQEhcqw.ttf","900italic":"http://fonts.gstatic.com/s/poppins/v20/pxiDyp8kv8JHgFVrJJLm81xlEN2PQEhcqw.ttf"},"category":"sans-serif","kind":"webfonts#webfont"}, type: 'fontselect', options: []},
	                            },
	                            {
	                           	font_style: {value: '', type: 'select', options: ['normal','italic','oblique','initial','inherit']},
	                            },
	                            {
	                           	font_weight: {value: '', type: 'select', options: [100,200,300,400,500,600,700,800,900]},
	                            },
	                           {
	                           	text_transform: {value: '', type: 'select', options: ['none','capitalize','uppercase','lowercase','initial','inherit']},
	                           },
	                           {
	                           	letter_spacing: {active: false, type: 'range', value: 'auto', units: '', unit_options: ['px'],  max: 124, min: 0, parentlabel: 'sizing_label'},
	                           },
	                           {
	                           	line_height: {active: false, type: 'range', value: 'auto', units: '', unit_options: ['px'],  max: 124, min: 0, parentlabel: 'sizing_label'}
	                            }
							],
				}
			},
			]
};


const themeClassElements = {styles:
	[							{
								display: {value: '', type: 'select', options: ['inline', 'block', 'contents', 'flex', 'grid', 'inline-block', 'inline-flex', 'inline-grid', 'inline-table', 'list-item', 'run-in', 'table', 'table-caption', 'table-column-group', 'table-header-group', 'table-footer-group', 'table-row-group', 'table-cell', 'table-column', 'table-row', 'none', 'initial', 'inherit']},
								},
								{
									box_shadow: {
										active: false,
										type: 'numbergroup-wcolor',
										h_offset: 0,
										v_offset: 0,
										blur: 0,
										spread: 0,
										value: '#000000',
										opacity: 0.01,
									},
								},
								{
								background_color: containerStyleObjects.border_colour
								},
								{
								border: containerStyleObjects.border
								},
								{
								border_color: containerStyleObjects.border_colour
								},
								{
								border_style: containerStyleObjects.border_style
								},
								{
									border_radius: {
										active: false,
										type: 'numbergroup',
										left: 0,
										right: 0,
										top: 0,
										bottom: 0,
									},
								},
								{
								text_colour: {
									active: false,
									value: '#000000',
									type: 'color'
								},
							},
								{font_size: {active: false, type: 'range', value: 'auto', units: '', unit_options: ['px'],  max: 124, min: 0, parentlabel: 'sizing_label'},
	                           	},
	                            {
	                           	font_family: {value: {"family":"Poppins","variants":["100","100italic","200","200italic","300","300italic","regular","italic","500","500italic","600","600italic","700","700italic","800","800italic","900","900italic"],"subsets":["devanagari","latin","latin-ext"],"version":"v20","lastModified":"2022-09-22","files":{"100":"http://fonts.gstatic.com/s/poppins/v20/pxiGyp8kv8JHgFVrLPTed3FBGPaTSQ.ttf","200":"http://fonts.gstatic.com/s/poppins/v20/pxiByp8kv8JHgFVrLFj_V1tvFP-KUEg.ttf","300":"http://fonts.gstatic.com/s/poppins/v20/pxiByp8kv8JHgFVrLDz8V1tvFP-KUEg.ttf","500":"http://fonts.gstatic.com/s/poppins/v20/pxiByp8kv8JHgFVrLGT9V1tvFP-KUEg.ttf","600":"http://fonts.gstatic.com/s/poppins/v20/pxiByp8kv8JHgFVrLEj6V1tvFP-KUEg.ttf","700":"http://fonts.gstatic.com/s/poppins/v20/pxiByp8kv8JHgFVrLCz7V1tvFP-KUEg.ttf","800":"http://fonts.gstatic.com/s/poppins/v20/pxiByp8kv8JHgFVrLDD4V1tvFP-KUEg.ttf","900":"http://fonts.gstatic.com/s/poppins/v20/pxiByp8kv8JHgFVrLBT5V1tvFP-KUEg.ttf","100italic":"http://fonts.gstatic.com/s/poppins/v20/pxiAyp8kv8JHgFVrJJLmE3tFOvODSVFF.ttf","200italic":"http://fonts.gstatic.com/s/poppins/v20/pxiDyp8kv8JHgFVrJJLmv1plEN2PQEhcqw.ttf","300italic":"http://fonts.gstatic.com/s/poppins/v20/pxiDyp8kv8JHgFVrJJLm21llEN2PQEhcqw.ttf","regular":"http://fonts.gstatic.com/s/poppins/v20/pxiEyp8kv8JHgFVrFJDUc1NECPY.ttf","italic":"http://fonts.gstatic.com/s/poppins/v20/pxiGyp8kv8JHgFVrJJLed3FBGPaTSQ.ttf","500italic":"http://fonts.gstatic.com/s/poppins/v20/pxiDyp8kv8JHgFVrJJLmg1hlEN2PQEhcqw.ttf","600italic":"http://fonts.gstatic.com/s/poppins/v20/pxiDyp8kv8JHgFVrJJLmr19lEN2PQEhcqw.ttf","700italic":"http://fonts.gstatic.com/s/poppins/v20/pxiDyp8kv8JHgFVrJJLmy15lEN2PQEhcqw.ttf","800italic":"http://fonts.gstatic.com/s/poppins/v20/pxiDyp8kv8JHgFVrJJLm111lEN2PQEhcqw.ttf","900italic":"http://fonts.gstatic.com/s/poppins/v20/pxiDyp8kv8JHgFVrJJLm81xlEN2PQEhcqw.ttf"},"category":"sans-serif","kind":"webfonts#webfont"}, type: 'fontselect', options: []},
	                            },
	                            {
	                           	font_style: {value: '', type: 'select', options: ['normal','italic','oblique','initial','inherit']},
	                            },
	                            {
	                           	font_weight: {value: '', type: 'select', options: [100,200,300,400,500,600,700,800,900]},
	                            },
	                           {
	                           	text_transform: {value: '', type: 'select', options: ['none','capitalize','uppercase','lowercase','initial','inherit']},
	                           },
	                           {
	                           	letter_spacing: {active: false, type: 'range', value: 'auto', units: '', unit_options: ['px'],  max: 124, min: 0, parentlabel: 'sizing_label'},
	                           },
	                           {
	                           	line_height: {active: false, type: 'range', value: 'auto', units: '', unit_options: ['px'],  max: 124, min: 0, parentlabel: 'sizing_label'}
	                            }
	]

}



export { containerStyles, rowStyles, columnStyles, widgetStyles, themeStyles, themeClassElements };